/** 还没有独立词条的界面原文 → 英文。其他语言未单列时也用这份，避免再显示中文。 */
export const FIXED_UI_EN = {
  "请先选择可用店铺": "Select an available shop first",
  "清除": "Clear",
  "业务待办": "Tasks",
  "请填写有效的同步分页数（≥1）": "Enter a valid sync page count (at least 1)",
  "终止成功": "Stopped",
  "报价信息": "Quote",
  "议价理由": "Bargain reason",
  "核价处理": "Price review",
  "至": "to",
  "判断方式": "Rule type",
  "平台建议价": "Platform suggested price",
  "外部链接": "External link",
  "核价单号": "Price-review no.",
  "申报价": "Declared price",
  "建议价": "Suggested price",
  "请选择图片文件": "Select an image file",
  "主站点": "Main site",
  "子站点": "Subsite",
  "站点缩写": "Site code",
  "已选类目": "Selected category",
  "已选末级分类": "Selected leaf category",
  "分类路径": "Category path",
  "分类 ID": "Category ID",
  "无匹配类目": "No matching category",
  "该模块将在下一阶段对接开放平台 API。": "This module will connect to the open platform API in a later phase.",
  "产品同步更新": "Sync products",
  "同步方式": "Sync method",
  "排队": "Queued",
  "请选择有效的开始和结束时间": "Select a valid start and end time",
  "开始时间必须早于结束时间": "Start time must be earlier than end time",
  "快捷时间段": "Quick ranges",
  "请选择开始时间": "Select a start time",
  "请选择结束时间": "Select an end time",
  "加载通知…": "Loading notices…",
  "关闭提醒": "Dismiss",
  "Webhook 事件详情": "Webhook event",
  "事件类型": "Event type",
  "处理状态": "Status",
  "已处理": "Processed",
  "失败/待处理": "Failed / pending",
  "处理备注": "Note",
  "原始 Payload": "Raw payload",
  "解密 Payload": "Decrypted payload",
  "正在处理中，请稍候": "Working, please wait",
  "拒绝阈值须小于同意阈值，中间留给人工处理": "The reject threshold must be lower than the accept threshold. The gap is left for manual review.",
  "该类目已有规则，请先删除后再添加": "This category already has a rule. Delete it before adding another.",
  "已加入规则列表，请点击保存生效": "Added to the rule list. Save to apply.",
  "低于 % 拒绝": "Reject below %",
  "不低于 % 同意": "Accept at or above %",
  "暂无规则，选类目并填写阈值后添加。": "No rules yet. Pick a category, set thresholds, then add.",
  "上次报价": "Last quote",
  "说明重新报价原因": "Explain the new quote",
  "支持批量，逗号分隔": "Batch input, separated by commas",
  "已清除该通知": "Notice cleared",
  "请填写联系邮箱": "Enter a contact email",
  "请填写问题描述": "Describe the issue",
  "问题描述至少 5 个字": "Use at least 5 characters",
  "反馈已发送至系统邮箱": "Feedback sent",
  "通知与帮助": "Notices and help",
  "搜索通知标题、内容或常见问题": "Search notices or FAQs",
  "帮助分区": "Help sections",
  "内容区": "Content",
  "通知渠道": "Notice channel",
  "渠道": "Channel",
  "级别": "Level",
  "内容": "Content",
  "问题": "Question",
  "没有匹配的常见问题": "No matching FAQs",
  "联系邮箱": "Contact email",
  "用于接收回复": "Used for replies",
  "问题描述": "Description",
  "请说明页面路径、操作步骤、报错或异常现象": "Include the page, steps, and the error you saw",
  "活动价": "Campaign price",
  "报名时间：": "Enrollment time:",
  "报名信息": "Enrollment",
  "活动起止": "Campaign period",
  "活动 ID": "Campaign ID",
  "开始日期": "Start date",
  "结束日期": "End date",
  "暂无 SKU": "No SKUs",
  "平台 SKU": "Platform SKU",
  "可用库存": "Available stock",
  "总库存": "Total stock",
  "上一年": "Previous year",
  "上一月": "Previous month",
  "下一月": "Next month",
  "下一年": "Next year",
  "时": "Hour",
  "分": "Minute",
  "秒": "Second",
  "请先选择店铺后再插入描述图片": "Select a shop before inserting a description image",
  "关闭预览": "Close preview",
  "缩小": "Zoom out",
  "重置为 100%": "Reset to 100%",
  "放大": "Zoom in",
  "图片无法预览": "Cannot preview this image",
  "预览大图": "Preview",
  "已刷新核价状态与待确认议价单": "Price-review status and pending bargains refreshed",
  "请先选择待确认议价单，或前往「价格处理 → 议价单」处理": "Select a pending bargain, or open Price handling → Bargains",
  "已跳转议价单：请对对应单据选择「重新报价」或处理新品核价复议。": "Opened bargains. Requote the matching row or handle the price review.",
  "自运营店铺请在卖家后台处理核价复议。": "For self-operated shops, handle price reviews in the seller backend.",
  "待确认议价单": "Pending bargains",
  "暂无待商家确认的议价单": "No bargains waiting for the seller",
  "复议说明（可选）": "Appeal note (optional)",
  "成本构成、竞品链接等，跳转议价单时可作参考": "Cost breakdown, competitor links, and similar notes for the bargain",
  "头像图片不能超过 5MB": "Avatar images must be 5MB or smaller",
  "店铺头像已更新": "Shop avatar updated",
  "加载店铺信息…": "Loading shop info…",
  "店铺 ID": "Shop ID",
  "更换店铺头像": "Change shop avatar",
  "点击上传自定义头像": "Upload a custom avatar",
  "正在查询店铺信息…": "Loading shop info…",
  "售卖站点": "Selling sites",
  "正在查询店铺发品资格…": "Checking listing permission…",
  "暂无发品资格数据，请同步后查看。": "No listing-permission data yet. Sync and try again.",
  "当前店铺具备发布商品资格。": "This shop can publish products.",
  "正在加载站点信息…": "Loading sites…",
  "Webhook 事件": "Webhook events",
  "已重新加载证书模板": "Certificate templates reloaded",
  "官方证书模板名称": "Official certificate template name",
  "平台未返回该类目属性，请确认类目或先同步店铺类目": "The platform returned no attributes. Check the category or sync shop categories.",
  "已重新加载属性库": "Attribute library reloaded",
  "当前类目无可填产品属性": "This category has no product attributes to fill",
  "请至少填写一项类目属性": "Fill in at least one category attribute",
  "正在加载类目属性…": "Loading category attributes…",
  "请先选择已授权的 SHEIN 店铺": "Select an authorized SHEIN shop first",
  "请先选择 SHEIN 店铺": "Select a SHEIN shop first",
  "报名记录 ID 无效": "Invalid enrollment ID",
  "指定同步请填写至少一个货品 SKC ID（productSkcId）": "Enter at least one product SKC ID (productSkcId) for a targeted sync",
  "多个 productSkcId 用换行、逗号或空格分隔，例如：5407624918": "Separate productSkcId values with new lines, commas, or spaces, for example 5407624918",
  "上传运单": "Upload waybill",
  "请填写物流商和运单号": "Enter the carrier and waybill number",
  "运单已提交": "Waybill submitted",
  "请填写有效数字": "Enter a valid number",
  "价格阈值不能为负数": "Price thresholds cannot be negative",
  "拒绝价格须小于同意价格，中间留给人工处理": "The reject price must be lower than the accept price. The gap is left for manual review.",
  "比例阈值请填写 0～100 的数字": "Enter a percentage from 0 to 100",
  "核价自动规则": "Automatic price-review rules",
  "低于（元）拒绝": "Reject below (CNY)",
  "不低于（元）同意": "Accept at or above (CNY)",
  "缺少核价单 orderId，无法重新报价": "Missing price-review orderId, so it cannot be requoted",
  "请填写至少一条议价理由（含原因类型）": "Add at least one bargain reason, including a reason type",
  "请选择合法的议价理由类型": "Select a valid bargain reason type",
  "议价理由最多 20 条": "At most 20 bargain reasons",
  "外部链接最多 5 个": "At most 5 external links",
  "请完善每个 SKU 的本次报价（元）": "Enter this quote (CNY) for every SKU",
  "缺少可报价的 SKU": "No SKU available to quote",
  "该 SKC 要求所有尺码同价，请填写相同报价": "This SKC requires the same price for every size",
  "本次报价（元）": "This quote (CNY)",
  "当前核价单未返回 SKU，无法填写报价": "This price review has no SKUs, so a quote cannot be entered",
  "原因类型": "Reason type",
  "具体原因（必填）": "Details (required)",
  "核价单状态": "Price-review status",
  "请选择待供应商确认的核价单": "Select price reviews waiting for the supplier",
  "批量输入核价单号": "Batch enter price-review numbers",
  "全选核价单": "Select all price reviews",
  "同步核价单": "Sync price reviews",
  "申报价填写方式": "How to enter the declared price",
  "活动要求": "Campaign requirements",
  "店铺资质": "Shop qualifications",
  "请先选择商品": "Select a product first",
  "限购数量须为 1 到 99，留空表示不限": "Purchase limit must be 1 to 99. Leave empty for no limit.",
  "活动开始时间：": "Campaign start:",
  "活动结束时间：": "Campaign end:",
  "活动名称：": "Campaign name:",
  "提报/剩余": "Submitted / remaining",
  "请填写名称和起止日期": "Enter a name and a start and end date",
  "同步接口尚未就绪": "The sync API is not ready yet",
  "列表接口尚未就绪": "The list API is not ready yet",
  "请勾选含发货单号的行，或同步打印中心后再试": "Select rows with a shipment number, or sync the print center and try again",
  "已打开打印页": "Print page opened",
  "价格同步接口尚未就绪": "The price sync API is not ready yet",
  "筛选": "Filter",
  "单号 / SKU / 状态": "Number / SKU / status",
  "可议价": "Can bargain",
  "寄样质检维度": "Sample QC",
  "加载模特列表…": "Loading models…",
  "已选模特": "Selected model",
  "暂无量体信息": "No measurements",
  "试穿尺码": "Try-on size",
  "请选择商品尺码": "Select a product size",
  "试穿感受": "Fit",
  "合身": "True to size",
  "请先在规格供应中选择尺码，再指定模特试穿尺码。": "Select sizes in specs first, then set the model's try-on size.",
  "一、确定发品类目": "1. Choose a category",
  "须选到叶子类目（isLeaf=true）。发品提交 cat1Id…cat10Id，不足补 0。": "Choose a leaf category (isLeaf=true). cat1Id through cat10Id are submitted, and missing levels are filled with 0.",
  "关键词匹配类目": "Match category by keyword",
  "根目录": "Root",
  "上一级": "Up",
  "二、确认站点、仓库、运费模板": "2. Confirm site, warehouse, and shipping template",
  "全托管/本土店铺可跳过本步。": "Fully managed and local shops can skip this step.",
  "例如 100": "For example 100",
  "刷新仓/运费": "Refresh warehouse / shipping",
  "三、属性与规格": "3. Attributes and specs",
  "货品规格（isSale=true）": "Sale specs (isSale=true)",
  "，可使用下方自定义规格": ". Custom specs below are available",
  "父规格": "Parent spec",
  "新规格值名称，如 红色": "New spec value, for example Red",
  "创建规格值": "Create spec value",
  "货品属性（isSale=false，含父子联动）": "Product attributes (isSale=false, including parent-child links)",
  "输入属性值": "Enter an attribute value",
  "四、尺码表": "4. Size chart",
  "选用已有模板": "Use an existing template",
  "新建一次性尺码表": "Create a one-off size chart",
  "暂无已有模板，请改用新建": "No templates yet. Create one instead.",
  "尺码表名称": "Size chart name",
  "五、图片和视频": "5. Images and video",
  "六、货品 SKC / SKU": "6. SKC / SKU",
  "货品名称 *": "Product name *",
  "站点供货价（元）": "Site supply price (CNY)",
  "供货价（元）": "Supply price (CNY)",
  "默认库存": "Default stock",
  "产地 region1": "Origin region1",
  "七、确认并发布": "7. Review and publish",
  "正在查询品牌…": "Loading brands…",
  "暂无可用品牌，请同步店铺信息后查看": "No brands yet. Sync shop info and try again.",
  "注册序列号": "Registration number",
  "全站点": "All sites",
  "启用": "Enabled",
  "模板名称 *": "Template name *",
  "请先选择模板": "Select a template first",
  "已批量删除": "Deleted",
  "已复制到个人模板": "Copied to personal templates",
  "支持 PDF / PNG / JPG，单文件 ≤ 20MB": "PDF / PNG / JPG, up to 20MB each",
  "合规资料维度": "Compliance files",
  "辅助材料": "Supporting files",
  "议价单号": "Bargain no.",
  "当前没有可填写的商品": "No products to fill in",
  "请先选择报名记录": "Select an enrollment first",
  "请先勾选要删除的本地商品（按 SPU）": "Select local products to delete (by SPU)",
  "请先勾选要上架的商品": "Select products to list",
  "请先勾选要下架的商品": "Select products to unlist",
  "正在查询商品分类…": "Loading categories…",
  "请先选择要报名的商品": "Select products to enroll",
  "显示语言": "Display language",
  "类目显示语言": "Category language",
  "物流商 ID": "Carrier ID",
  "请输入运单号": "Enter the waybill number",
  "产品ID，支持批量": "Product ID, comma-separated",
  "可点「拉取 TikTok 后台数据」获取平台核价单": "Pull TikTok data to load platform price reviews",
  "商家改价": "Seller price change",
  "如何改价": "How to change a price",
  "打开「产品信息」→ 进入商品编辑 → 按 SKU 调整价格后提交。": "Open Product info, edit the product, adjust the SKU price, then submit.",
  "仅改价时走 Update Price，一般不会把整品重新送审。": "Price-only updates use Update Price and usually do not resubmit the whole product for review.",
  "价格须符合各市场允许区间；活动折扣请用「营销活动」中的 Discount / Flash Deal。": "Prices must stay in each market's allowed range. Use Discount / Flash Deal in Marketing for campaign discounts.",
  "近 28 天": "Last 28 days",
  "店铺表现": "Shop performance",
  "商品表现": "Product performance",
  "成交件数": "Units sold",
  "订单数": "Orders",
  "客单价": "Average order value",
  "日均买家": "Daily buyers",
  "退款金额": "Refund amount",
  "日均访客": "Daily visitors",
  "日均浏览": "Daily page views",
  "转化率": "Conversion rate",
  "分时": "By hour",
  "短视频": "Short videos",
  "直播": "Live",
  "体验分": "Experience score",
  "商品卡": "Product card",
  "所选日期没有商品表现数据": "No product performance for the selected dates",
  "最近拉取": "Last pull",
  "加载经营数据失败": "Failed to load business data",
  "拉取失败": "Pull failed",
  "平台 code": "Platform code",
  "从 TikTok 后台拉取所选日期的店铺和商品表现，并写入本地快照。": "Pull shop and product performance for the selected dates from TikTok and save a local snapshot.",
  "提报商品": "Submit products",
  "报名": "Enroll",
  "平台标记为不可修改": "The platform marked this activity as not editable",
  "请先同步「活动列表」，再在本页点击「拉取 TEMU 后台数据」并行拉取报名记录、活动商品与场次。": "Sync Activities first, then pull TEMU data on this page to load enrollments, products, and sessions.",
  "点击「拉取 TEMU 后台数据」拉取可报名活动、详情与场次。": "Pull TEMU data to load activities you can join, plus details and sessions.",
  "点击工具栏右侧「拉取 SHEIN 后台数据」获取平台报名记录。": "Pull SHEIN data from the toolbar to load enrollment records.",
  "请先到「活动列表」点击「拉取 SHEIN 后台数据」获取可报名活动，再回到本页点「拉取 SHEIN 后台数据」获取报名记录。": "Pull SHEIN data on Activities first, then come back and pull again for enrollment records.",
  "点击工具栏右侧「拉取 SHEIN 后台数据」获取平台可报名活动。": "Pull SHEIN data from the toolbar to load activities you can join.",
  "曝光": "Impressions",
  "点击": "Clicks",
  "点击率": "Click rate",
  "更多经营分析": "More analytics",
  "对象": "Item",
  "GMV / 指标": "GMV / metric",
  "当前维度没有列表数据": "No rows for this view",
  "新商品请从活动列表的「提报商品」进入报名页选择。": "For new products, open Enroll products from the campaign list.",
  "正在读取活动的报价维度": "Loading the campaign's pricing fields",
  "报名已提交": "Enrollment submitted",
  "产品 ID / 名称 / 货号": "Product ID / name / supplier code",
  "请从活动列表进入，以便带上店铺。": "Open this from the campaign list so the shop is included.",
  "批量折扣（%）": "Bulk discount (%)",
  "批量活动价": "Bulk campaign price",
  "批量限购": "Bulk purchase limit",
  "折扣（%）": "Discount (%)",
  "活动折扣": "Campaign discount",
  "折后价": "Price after discount",
  "限购": "Purchase limit",
  "没有可报名的在售商品，请先在商品管理同步": "No listed products to enroll. Sync products first.",
  "请先选中活动": "Select a campaign first",
  "创建促销活动": "Create promotion",
  "活动已创建，请刷新列表": "Campaign created. Refresh the list.",
  "满减": "Spend and save",
  "买 X 送 Y": "Buy X get Y",
  "更新活动": "Update campaign",
  "活动已更新": "Campaign updated",
  "重新发布活动": "Republish campaign",
  "请填写新的起止日期": "Enter a new start and end date",
  "活动已重新发布": "Campaign republished",
  "重新发布": "Republish",
  "请填写名称、邮箱、地址与联系电话": "Enter the name, email, address, and phone",
  "新建制造商": "New manufacturer",
  "新建欧盟负责人": "New EU responsible person",
  "语言档案（locale）": "Locale profile",
  "如 en-IE / de-DE": "For example en-IE / de-DE",
  "认证文件仅支持 PDF": "Certificates must be PDF files",
  "单个 PDF 不能超过 20MB": "Each PDF must be 20MB or smaller",
  "认证文件已上传": "Certificate uploaded",
  "正在加载类目规则…": "Loading category rules…",
  "认证资质": "Certifications",
  "（按条件选填）": "(required only when conditions match)",
  "已命中属性条件，本条认证当前为必填。": "Attribute conditions matched. This certificate is required.",
  "认证文件（PDF）": "Certificate file (PDF)",
  "部分认证要求上传 PDF 证明文件（单个 ≤20MB）。": "Some certifications require a PDF (up to 20MB).",
  "认证图片以 use_case=CERTIFICATION_IMAGE 上传；认证 PDF 走平台 Upload Product File（/product/202309/files/upload）。": "Certificate images use use_case=CERTIFICATION_IMAGE. Certificate PDFs use Upload Product File (/product/202309/files/upload).",
  "制造商": "Manufacturer",
  "请选择制造商（选填）": "Select a manufacturer (optional)",
  "添加责任人": "Add a responsible person",
  "请选择责任人（选填）": "Select a responsible person (optional)",
  "货到付款（COD）": "Cash on delivery (COD)",
  "允许 COD": "Allow COD",
  "不设置（平台默认）": "Not set (platform default)",
  "支持 COD": "COD supported",
  "不支持 COD": "COD not supported",
  "本类目支持 COD；若设为「不支持」，买家结算页不展示货到付款。": "This category supports COD. If you choose not supported, checkout hides cash on delivery.",
  "押金（PFAND）": "Deposit (PFAND)",
  "押金金额": "Deposit amount",
  "如 0.25": "For example 0.25",
  "包装属性": "Packaging attributes",
  "押金按 SKU 提交（": "The deposit is submitted per SKU (",
  "），当前金额会应用到全部 SKU。取值范围 0.00–6300.00。": "). This amount applies to every SKU. Allowed range: 0.00–6300.00.",
  "生产者责任延伸（EPR）": "Extended producer responsibility (EPR)",
  "描述图片已插入": "Description image inserted",
  "描述编辑工具栏": "Description toolbar",
  "撤销": "Undo",
  "重做": "Redo",
  "清除格式": "Clear formatting",
  "插入图片（本地 / 图片空间）": "Insert image (local / library)",
  "加粗": "Bold",
  "斜体": "Italic",
  "下划线": "Underline",
  "无序列表": "Bulleted list",
  "有序列表": "Numbered list",
  "选择模特": "Select a model",
  "从店铺模特中选择": "Choose from shop models",
  "TikTok 平台操作": "TikTok actions",
  "当前店铺模式无成本议价单；请在 TikTok 卖家后台完成核价确认。": "This shop mode has no cost bargains. Confirm prices in TikTok Seller Center.",
  "正在获取类目尺码表规则…": "Loading category size-chart rules…",
  "请先在顶部选择单个 TikTok 店铺后再发品。": "Select one TikTok shop in the top bar before publishing.",
  "TikTok 货品发布": "Publish to TikTok",
  "半托管须配置仓库；运费模板选填（不可用可留空不传）。": "Semi-managed shops need a warehouse. The shipping template is optional.",
  "正在查询可发类目…": "Loading categories you can publish…",
  "暂无店铺基础信息，请点击「拉取 TikTok 后台数据」同步。": "No shop profile yet. Pull TikTok data to sync.",
  "请先选择尺寸，表格将按所选尺码自动生成。": "Select sizes first. The table is generated from them.",
  "商品类型 ID": "Product type ID",
  "上级分类 ID": "Parent category ID",
  "指定同步请填写至少一个 SPU": "Enter at least one SPU for a targeted sync",
  "同步分页数（商品列表 pageSize=200，页数上限）": "Sync pages (product list pageSize=200, page cap)",
  "多个 SPU 用换行、逗号或空格分隔": "Separate SPUs with new lines, commas, or spaces",
  "没有拥有该类目的店铺，无法复制": "No shop owns this category, so it cannot be copied",
  "选择要同步订单的店铺": "Select a shop to sync orders",
  "产品合规维度": "Product compliance",
  "自动拒绝阈值请填写 0～100 的数字": "Enter an auto-reject threshold from 0 to 100",
  "自动同意阈值请填写 0～100 的数字": "Enter an auto-accept threshold from 0 to 100",
  "议价自动规则": "Automatic bargain rules",
  "请完善每个 SKU 的报价与币种": "Enter a quote and currency for every SKU",
  "该 SKC 要求所有尺码同价，请填写相同成本价": "This SKC requires the same cost for every size",
  "缺少店铺信息，无法上传": "Shop info is missing, so the file cannot be uploaded",
  "本次报价": "This quote",
  "可选，最多 255 字": "Optional, up to 255 characters",
  "支持图片，可多选": "Images, multiple allowed",
  "议价单状态": "Bargain status",
  "请选择待商家确认的议价单": "Select bargains waiting for the seller",
  "批量输入议价单号": "Batch enter bargain numbers",
  "议价单类型": "Bargain type",
  "全选议价单": "Select all bargains",
  "报价": "Quote",
  "轮次/剩余": "Round / remaining",
  "改价原因": "Price-change reason",
  "同步议价单": "Sync bargains",
  "本地商品库未匹配到该 SPU / SKU，请确认后重试": "No local product matched this SPU / SKU. Check and try again.",
  "或": "or",
  "要填写的数据": "Fields to fill",
  "活动信息未就绪": "Campaign info is not ready",
  "活动详情未就绪（当前为本地活动列表兜底），请稍后重试后再提交": "Campaign details are not ready (showing the local list). Try again before submitting.",
  "请先勾选要报名的商品": "Select products to enroll",
  "所选商品均已在报名任务中，请等待完成后再试": "These products are already enrolling. Wait until that finishes.",
  "单次最多报名 100 个 SKC，请分批提交": "Enroll at most 100 SKCs at a time",
  "切换填写口径：调整价 / 折扣": "Switch entry mode: adjusted price / discount",
  "按折扣自动计算的活动价": "Campaign price calculated from the discount",
  "批量填写口径": "Bulk entry mode",
  "切换批量填写口径：调整价 / 折扣": "Switch bulk entry: adjusted price / discount",
  "查询字段": "Search field",
  "批量输入": "Batch enter",
  "全选当前页 SKC": "Select all SKCs on this page",
  "预留": "Reserved",
  "活动 ID 无效": "Invalid campaign ID",
  "所选记录均已在取消任务中，请等待完成后再试": "These records are already being cancelled. Wait until that finishes.",
  "单次最多取消 100 条，请分批提交": "Cancel at most 100 rows at a time",
  "仅审核中的报名可取消": "Only enrollments in review can be cancelled",
  "该报名已在取消任务中，请等待完成": "This enrollment is already being cancelled",
  "已删除本地记录": "Local record deleted",
  "所选记录中没有可取消的报名（仅审核中可取消）": "None of the selected enrollments can be cancelled (only those in review)",
  "所选可取消记录均已在取消任务中，请等待完成后再试": "The cancellable rows are already being cancelled. Wait and try again.",
  "活动件数：": "Campaign quantity:",
  "预留件数：": "Reserved quantity:",
  "请先在右上角选择已授权的 SHEIN 店铺": "Select an authorized SHEIN shop in the top-right corner",
  "SHEIN 平台操作": "SHEIN actions",
  "明细加载中…": "Loading details…",
  "当前店铺模式无成本议价单；请在 SHEIN 卖家后台完成核价确认。": "This shop mode has no cost bargains. Confirm prices in SHEIN Seller Center.",
  "正在查询品牌与 IP…": "Loading brands and IPs…",
  "暂无可用品牌": "No brands available",
  "暂无可用 IP": "No IPs available",
  "中文名称": "Chinese name",
  "IP 组": "IP group",
  "按层级浏览可用类目；发品时请选择末级分类。": "Browse categories by level. Choose a leaf category when publishing.",
  "店铺信息同步成功": "Shop info synced",
  "暂无店铺基础信息，请点击「同步店铺信息」同步。": "No shop profile yet. Sync shop info.",
  "发品可用额度": "Listing quota",
  "暂无额度数据，请同步后查看。": "No quota data yet. Sync and try again.",
  "发品资格": "Listing permission",
  "品牌与 IP": "Brands and IP",
  "暂无站点数据，请点击右上角「同步店铺信息」从 SHEIN 同步。": "No site data yet. Sync shop info from SHEIN.",
  "店铺模式": "Shop mode",
  "暂无可打印的平台 JSON": "No platform JSON to print",
  "已打印到控制台（F12 查看）": "Printed to the console (see F12)",
  "可点「拉取 TEMU 后台数据」获取平台核价单": "Pull TEMU data to load platform price reviews",
  "货品 productId": "Product ID",
  "请先填写货品 ID": "Enter the product ID first",
  "请输入有效的活动库存": "Enter a valid campaign stock",
  "请输入有效的申报价": "Enter a valid declared price",
  "未能根据供货价计算申报价，请检查供货价是否完整": "Could not calculate the declared price from the supply price. Check that the supply price is complete.",
  "请先选择场次": "Select a session first",
  "请先选择站点": "Select a site first",
  "SPU，支持逗号批量": "SPU, comma-separated",
  "批量输入 SPU": "Batch enter SPUs",
  "可报名商品列表": "Products you can enroll",
  "全选当前页商品": "Select all products on this page",
  "活动专题 ID 无效": "Invalid campaign topic ID",
  "活动类型无效": "Invalid campaign type",
  "请先勾选活动": "Select campaigns first",
  "报名场次状态": "Session status",
  "请先在右上角选择已授权的 TEMU 店铺": "Select an authorized TEMU shop in the top-right corner",
  "平台 JSON · 商品": "Platform JSON · product",
  "当前类目要求填写模特信息": "This category requires model info",
  "TEMU 平台操作": "TEMU actions",
  "当前店铺模式无成本议价单；请在 TEMU 卖家后台完成核价确认。": "This shop mode has no cost bargains. Confirm prices in TEMU Seller Center.",
  "请先在顶部选择单个 TEMU 店铺后再发品。": "Select one TEMU shop in the top bar before publishing.",
  "TEMU 货品发布": "Publish to TEMU",
  "半托管须配置仓库与运费模板。": "Semi-managed shops need a warehouse and a shipping template.",
  "省份 region2Id": "Province region2Id",
  "暂无店铺基础信息，请点击「拉取 TEMU 后台数据」同步。": "No shop profile yet. Pull TEMU data to sync.",
  "暂无站点数据。": "No site data.",
  "按平台填写规则上传": "Upload using the platform rules",
  "本地存储 · 复制到店铺时转平台 · PDF / PNG / JPG ≤ 20MB": "Stored locally, sent to the platform when copied to a shop · PDF / PNG / JPG up to 20MB",
  "同步中…": "Syncing…",
  "请选择或搜索类目": "Select or search a category",
  "同步失败": "Sync failed",
  "全部类目": "All categories",
  "删除": "Delete",
  "重置": "Reset",
  "已更新": "Updated",
  "正在加载…": "Loading…",
  "已取消裁剪": "Crop cancelled",
  "上传失败": "Upload failed",
  "确定": "Confirm",
  "完成": "Done",
  "查看": "View",
  "导出筛选失败": "Failed to export the filtered rows",
  "加载同步 dump…": "Loading sync dump…",
  "下载失败": "Download failed",
  "重新加载 dump": "Reload dump",
  "下载 dump": "Download dump",
  "复制当前": "Copy current",
  "去处理": "Handle",
  "开始同步": "Start sync",
  "刷新中…": "Refreshing…",
  "正在终止…": "Stopping…",
  "同意平台建议价": "Accept the platform price",
  "活动专题": "Campaign topic",
  "加载模板失败": "Failed to load the template",
  "重新加载失败": "Reload failed",
  "缺少适用类目": "Missing category",
  "同步更新": "Sync",
  "批量删除": "Delete selected",
  "尚未同步": "Not synced yet",
  "请输入": "Enter",
  "模板已更新": "Template updated",
  "模板已创建": "Template created",
  "更新失败": "Update failed",
  "颜色": "Color",
  "全选已加载": "Select all loaded",
  "同步店铺信息": "Sync shop info",
  "时间类型": "Time field",
  "启动中…": "Starting…",
  "刷新": "Refresh",
  "全部站点": "All sites",
  "批量同意": "Accept selected",
  "批量提交后台": "Submit selected",
  "处理中…": "Working…",
  "待商家确认": "Awaiting seller",
  "待平台审核": "Pending platform review",
  "接受议价": "Bargain accepted",
  "不接受议价": "Bargain declined",
  "议价终止-成功": "Bargain ended — success",
  "议价终止-失败": "Bargain ended — failed",
  "待核价": "Pending review",
  "待供应商确认": "Awaiting supplier",
  "核价通过": "Price approved",
  "核价驳回": "Price rejected",
  "废弃": "Discarded",
  "价格同步中": "Syncing price",
  "公司代理": "Company agents",
  "实拍图": "Live photos",
  "环保耗材": "Eco materials",
  "合规标签": "Compliance labels",
  "代理绑定": "Agent binding",
  "证书绑定": "Certificate binding",
  "负责人": "Responsible person",
  "寄样单": "Samples",
  "质检单": "QC orders",
  "退供单": "Return-to-supplier",
  "待上传": "To upload",
  "上传中": "Uploading",
  "上传成功": "Uploaded",
  "未审核": "Not reviewed",
  "审核成功": "Approved",
  "审核驳回": "Rejected",
  "详情": "Details",
  "可报商品": "Eligible products",
  "场次": "Sessions",
  "店铺维度": "Shop",
  "筛选店铺名称": "Filter shops",
  "筛选店铺": "Filter shops",
  "更多店铺": "More shops",
  "收起": "Show less",
  "店铺 ID (Seller Id)": "Shop ID (Seller Id)",
  "店铺 Cipher": "Shop Cipher",
  "Open ID": "Open ID",
  "授权过期时间": "Authorization expiry",
  "授权过期": "Authorization expired",
  "待授权": "Pending authorization",
  "最近同步": "Last sync",
  "正在同步…": "Syncing…",
  "正在从 SHEIN 同步…": "Syncing from SHEIN…",
  "暂无缓存，请点击「同步店铺信息」从 SHEIN 同步": "No cache yet. Click Sync shop info to load it from SHEIN.",
  "未启用": "Disabled",
  "停用": "Disabled",
  "平台类型": "Platform",
  "自营类型": "Seller",
  "店铺类型代码": "Shop type code",
  "店铺地区": "Shop region",
  "店铺状态": "Shop status",
  "商家业务类型": "Business type",
  "可用额度": "Available quota",
  "总额度": "Total quota",
  "已用额度": "Used quota",
  "美区": "US",
  "欧区": "EU",
  "全球": "Global",
  "美国 POP 店": "US POP shop",
  "跨境 POP 店": "Cross-border POP shop",
  "点击头像可自定义；未设置时顶栏默认显示 TikTok": "Click the avatar to customize it. The top bar shows TikTok until you set one.",
  "点击头像可自定义；未设置时顶栏默认显示 SHEIN": "Click the avatar to customize it. The top bar shows SHEIN until you set one.",
  "点击头像可自定义；未设置时顶栏默认显示 TEMU": "Click the avatar to customize it. The top bar shows TEMU until you set one.",
  "在左侧逐级选择分类；下级类目点击后按需从平台加载。": "Select categories on the left. Child categories load from the platform when opened.",
  "在左侧逐级选择分类，末级分类将显示发品所需信息。": "Select categories on the left. A leaf category shows the fields required to publish.",
  "请逐级选择至末级类目。": "Select level by level until a leaf category.",
  "全部视图下请选择一家店铺后再同步店铺信息。": "In the all-shops view, pick one shop before syncing shop info.",
  "尚未配置 TikTok 店铺。": "No TikTok shop is set up yet.",
  "尚未配置 SHEIN 店铺。": "No SHEIN shop is set up yet.",
  "尚未配置 TEMU 店铺。": "No TEMU shop is set up yet.",
  "去平台管理 · 店铺管理": "Platform management · Shops",
  "去平台模板 · 店铺管理": "Platform templates · Shops",
  "尚未同步到授权/经营站点；点击「拉取 TikTok 后台数据」获取授权/经营站点列表。": "Selling sites are not synced yet. Pull TikTok data to load them.",
  "暂无可发类目缓存。请点击「拉取 TikTok 后台数据」从平台拉取。": "No category cache yet. Pull TikTok data to load categories.",
  "全托管店铺售卖站点默认按全站点（ALL）处理；分区站点仅半托管店铺展示。": "Fully managed shops use All sites. Region sites are shown for semi-managed shops.",
  "半托管未同步到本店站点时按官方已开站目录分区展示；仓库同步拿到站点后会替换为本店列表。全托管店铺固定展示全站点。": "Until this semi-managed shop syncs its sites, the official site catalog is shown by region. A warehouse sync replaces it with this shop's sites. Fully managed shops always show All sites.",
  "售卖站点按美区 / 欧区 / 全球分区展示（半托管）；全托管店铺固定展示全站点。": "Semi-managed selling sites are grouped as US, EU, and Global. Fully managed shops always show All sites.",
  "活动列表": "Campaigns",
  "启动同步失败": "Failed to start sync",
  "发货中": "Shipping…",
  "安排发货": "Arrange shipment",
  "打印面单": "Print label",
  "获取中": "Loading…",
  "帮助": "Help",
  "默认全量": "Full sync",
  "指定 SKC": "Specific SKCs",
  "重新加载": "Reload",
  "下载": "Download",
  "复制": "Copy",
  "加载下级类目失败": "Failed to load child categories",
  "请逐级选择至末级类目（下级按需加载）。": "Select level by level until a leaf category. Child categories load on demand.",
  "读取同步 dump 失败（请先点「拉取 TikTok 后台数据」）": "Failed to read the sync dump. Pull TikTok data first.",
  "暂无平台同步 JSON": "No platform sync JSON",
  "申请": "Applied",
  "签收": "Signed",
  "暂无平台通知。核价、同步、平台推送等相关提醒会显示在这里。": "No platform notices. Price reviews, sync, and platform alerts show up here.",
  "暂无系统通知。店铺授权与同步异常等会显示在这里。": "No system notices. Shop authorization and sync errors show up here.",
  "查看轨迹": "View tracking",
  "发货仓": "Shipping warehouse",
  "退货仓": "Return warehouse",
  "本土仓": "Domestic warehouse",
  "跨境海外仓": "Cross-border overseas warehouse",
  "跨境直邮仓": "Cross-border direct shipping warehouse",
  "跨境直发仓": "Cross-border direct shipping warehouse",
  "可用": "Available",
  "受限": "Restricted",
  "平台物流模板": "Platform logistics template",
  "商家物流模板": "Seller logistics template",
  "成衣模特": "Apparel model",
  "鞋类模特": "Footwear model",
  "进入 SHEIN 工作区": "Enter the SHEIN workspace",
  "进入 TikTok 工作区": "Enter the TikTok workspace",
  "进入 TEMU 工作区": "Enter the TEMU workspace",
  "TikTok 工作区": "TikTok workspace",
  "TEMU 工作区": "TEMU workspace",
  "电商平台": "Commerce platforms",
  "编辑产品": "Edit product",
  "编辑产品模板": "Edit product template",
  "新建产品模板": "New product template",
  "请点击「查询」或「拉取 TikTok 后台数据」": "Click Search or Pull TikTok data",
  "未命名货品": "Unnamed product",
  "未命名商品": "Unnamed product",
  "提报:": "Submitted:",
  "剩余:": "Remaining:",
  "正常": "Normal",
  "选择同步时间段": "Choose a sync time range",
  "近 24 小时": "Last 24 hours",
  "近 48 小时": "Last 48 hours",
  "近 14 天": "Last 14 days",
  "近 30 天": "Last 30 days",
  "每状态最多页数": "Max pages per status",
  "默认": "Default",
  "上限": "Max",
  "同步分页数": "Sync page count",
  "同步分页数最多": "Max sync pages",
  "货品 SKC ID": "Product SKC ID",
  "最多": "Up to",
  "更换": "Change",
  "加载价格明细失败": "Failed to load price details",
  "查看平台价格明细": "View platform price details",
  "商品金额": "Item amount",
  "运费": "Shipping",
  "平台折扣": "Platform discount",
  "卖家折扣": "Seller discount",
  "买家实付": "Buyer paid",
  "上传运单失败": "Failed to upload tracking",
  "提交运单": "Submit tracking",
  "提交中": "Submitting",
  "排队中": "Queued",
  "前方还有": "ahead",
  "个店铺": "shops",
  "您排第": "place",
  "共": "total",
  "店在排队": "shops queued",
  "并行": "parallel",
  "排队中，即将开始": "Queued, starting soon",
  "已同步": "Synced",
  "个 SKC": "SKC",
  "个 SPU": "SPU",
  "条": "rows",
  "同步": "Sync",
  "前方": "Ahead",
  "终止中…": "Stopping…",
  "终止": "Stop",
  "已入库": "Saved",
  "暂无选项": "No options",
  "当前店铺": "Current shop",
  "全部通知": "All notices",
  "常见问题": "FAQ",
  "问题反馈": "Feedback",
  "平台通知": "Platform notices",
  "系统通知": "System notices",
  "平台推送": "Platform push",
  "系统同步": "System sync",
  "异常": "Error",
  "警告": "Warning",
  "添加理由": "Add reason",
  "批量拒绝": "Bulk reject",
  "已配置规则": "Configured rules",
  "同步状态加载中…": "Loading sync status…",
  "个模块同步异常": "modules failed to sync",
  "全部模块已同步": "All modules synced",
  "模块已同步": "modules synced",
  "失败": "Failed",
  "刷新状态": "Refresh status",
  "开始日期必须早于或等于结束日期": "Start date must be on or before the end date",
  "发布记录": "Publish records",
  "证书": "Certificates",
  "证书库": "Certificate library",
  "合规": "Compliance",
  "产品模板复制": "Copy product templates",
  "实拍图模板复制": "Copy live-photo templates",
  "证书库复制": "Copy certificate library",
  "实拍图自动绑定": "Auto-bind live photos",
  "证书自动绑定": "Auto-bind certificates",
  "代理自动绑定": "Auto-bind agents",
  "财务账单": "Finance bills",
  "退货单": "Returns",
  "取消单": "Cancellations",
  "尺码表": "Size chart",
  "成本议价单": "Cost quotes",
  "建议零售价审核": "RRP review",
  "合规代理绑定": "Compliance agent binding",
  "代理公司": "Agent companies",
  "仓库库存": "Warehouse stock",
  "活动商品": "Campaign products",
  "经营数据": "Analytics",
  "报名记录": "Enrollment records",
  "产品证书资质": "Product certificates",
  "TikTok 商品描述须为英文，可含简单 HTML。": "TikTok descriptions must be in English and may include simple HTML.",
  "退出全屏": "Exit full screen",
  "全屏编辑": "Full screen",
  "描述图片上传失败": "Failed to upload the description image",
  "已插入": "Inserted",
  "张描述图片": "description images",
  "从图片空间插入失败": "Failed to insert from the image library",
  "请先在规格供应中选择尺码，尺寸表将按所选尺码自动增减行。": "Select sizes in the variant section first. The size chart rows follow the selected sizes.",
  "其他": "Other",
  "产地为中国时请选择省份": "Select a province when the origin is China",
  "日常核价": "Regular price review",
  "活动核价": "Campaign price review",
  "新品议价": "New product bargain",
  "老品议价": "Existing product bargain",
  "新品核价复议": "New product price appeal",
  "材质": "Material",
  "功能": "Function",
  "品类": "Category",
  "外观": "Appearance",
  "版型": "Fit",
  "图案": "Pattern",
  "规格尺寸": "Size",
  "品牌": "Brand",
  "添加链接": "Add link",
  "尚未同步，请点击「拉取 TikTok 后台数据」": "Not synced yet. Click Pull TikTok data.",
  "尚未同步，请点击「拉取 SHEIN 后台数据」": "Not synced yet. Click Pull SHEIN data.",
  "尚未同步，请点击「拉取 TEMU 后台数据」": "Not synced yet. Click Pull TEMU data.",
  "关键词": "Keyword",
  "活动名称 / 活动 ID": "Campaign name / campaign ID",
  "活动类型": "Campaign type",
  "开始时间": "Start time",
  "结束时间": "End time",
  "采购子单号 / 货号 / 商品名": "PO number / SKU / product name",
  "采购子单号": "PO number",
  "收货仓": "Receiving warehouse",
  "状态/紧急度": "Status / urgency",
  "最晚到货": "Latest arrival",
  "质检单 / 采购单 / 产品ID": "QC order / PO / product ID",
  "采购单": "Purchase order",
  "结果": "Result",
  "退供单号 / 订单号": "Return number / order number",
  "退供单号": "Return number",
  "关联订单": "Related order",
  "发货单号 / 运单号": "Shipment number / tracking number",
  "发货单号": "Shipment number",
  "寄样单号 / 产品ID": "Sample number / product ID",
  "寄样单号": "Sample number",
  "包装任务 / SKU": "Packing task / SKU",
  "任务/ID": "Task / ID",
  "广告计划 / 商品": "Ad plan / product",
  "计划名称": "Plan name",
  "预算": "Budget",
  "同步时间": "Synced at",
  "SKU / 产品ID / 商品名": "SKU / product ID / product name",
  "今日销量": "Sales today",
  "近7日": "Last 7 days",
  "近30日": "Last 30 days",
  "剩余库存": "Stock left",
  "名称 / 编号": "Name / number",
  "导出选中 CSV": "Export selected CSV",
  "复制选中编号": "Copy selected numbers",
  "打印中…": "Printing…",
  "批量打印箱唛": "Print box labels",
  "打印箱唛": "Print box label",
  "点击「拉取 TikTok 后台数据」": "Click Pull TikTok data",
  "点击「拉取 TEMU 后台数据」": "Click Pull TEMU data",
  "请调整筛选条件或清空后重试。": "Adjust the filters or clear them and try again.",
  "箱唛": "Box label",
  "新建": "New",
  "请输入模板名称": "Enter a template name",
  "正在查询…": "Loading…",
  "加载失败": "Failed to load",
  "已保存": "Saved",
  "已创建": "Created",
  "保存失败": "Failed to save",
  "删除失败": "Failed to delete",
  "批量删除失败": "Failed to delete the selection",
  "更新自动规则失败": "Failed to update the auto rule",
  "归属": "Scope",
  "暂无平台选项": "No platform options",
  "可报名": "Can enroll",
  "暂不可报名": "Cannot enroll yet",
  "填报项": "Fields",
  "无需填报": "Nothing to fill in",
  "活动时间：": "Campaign time:",
  "加载活动详情中…": "Loading campaign details…",
  "活动详情未就绪": "Campaign details are not ready",
  "提交报名": "Submit enrollment",
  "已选": "Selected",
  "进行中": "In progress",
  "报名中…": "Enrolling…",
  "当前有": "There are",
  "个报名任务在后台执行": "enrollment jobs running in the background",
  "报名任务已在后台异步执行；已锁定本任务 SKC，其它商品可继续提交。完成后可到「报名记录」查看审核状态。": "Enrollment is running in the background. SKCs in this job are locked; other products can still be submitted. Check review status in Enrollment records when it finishes.",
  "SKC 数": "SKC count",
  "库存": "Stock",
  "超过 20MB": "exceeds 20MB",
  "上传失败：未返回文件地址": "upload failed: no file URL returned",
  "季节": "Season",
  "店铺授权": "Shop authorization",
  "合规资质": "Compliance",
  "退货退款": "Returns",
  "通知": "Notices",
  "网关区域": "Gateway region",
  "未开站或缺少对应区 Token": "Site is not open, or the region token is missing",
  "店铺显示未授权或授权失效怎么办？": "The shop shows unauthorized or the authorization expired?",
  "请到「店铺信息」确认授权状态。若已过期，重新完成 TikTok 开放平台授权后刷新工作区。授权异常也会出现在系统通知中。": "Open Shop info and check the authorization. If it expired, authorize again in TikTok Shop Open Platform and refresh the workspace. Authorization errors also appear in system notices.",
  "请到「店铺信息」确认授权状态。若已过期，重新完成 SHEIN 开放平台授权后刷新工作区。授权异常也会出现在系统通知中。": "Open Shop info and check the authorization. If it expired, authorize again in SHEIN Open Platform and refresh the workspace. Authorization errors also appear in system notices.",
  "请到「店铺信息」确认授权状态。若已过期，重新完成 TEMU 开放平台授权后刷新工作区。授权异常也会出现在系统通知中。": "Open Shop info and check the authorization. If it expired, authorize again in TEMU Open Platform and refresh the workspace. Authorization errors also appear in system notices.",
  "同步更新失败或进度条中断？": "Sync failed or the progress bar stopped?",
  "先确认当前店铺已授权。可在对应业务页（商品 / 证书 / 合规 / 财务 / 订单）再次点击「拉取 TikTok 后台数据」。若持续失败，查看系统通知中的同步异常说明。": "Confirm the shop is authorized. On the product, certificate, compliance, finance, or order page, click Pull TikTok data again. If it keeps failing, read the sync error in system notices.",
  "先确认当前店铺已授权。可在对应业务页（商品 / 证书 / 合规 / 财务 / 订单）再次点击「拉取 SHEIN 后台数据」。若持续失败，查看系统通知中的同步异常说明。": "Confirm the shop is authorized. On the product, certificate, compliance, finance, or order page, click Pull SHEIN data again. If it keeps failing, read the sync error in system notices.",
  "先确认当前店铺已授权。可在对应业务页（商品 / 证书 / 合规 / 财务 / 订单）再次点击「拉取 TEMU 后台数据」。若持续失败，查看系统通知中的同步异常说明。": "Confirm the shop is authorized. On the product, certificate, compliance, finance, or order page, click Pull TEMU data again. If it keeps failing, read the sync error in system notices.",
  "待办事项的数字和合规资料不一致？": "The to-do count does not match compliance records?",
  "待办事项的数字和产品合规不一致？": "The to-do count does not match product compliance?",
  "待办事项的数字和合规信息不一致？": "The to-do count does not match compliance info?",
  "首页「合规资质待办」的「拉取 TikTok 后台数据」只重算本地已入库数据，不会再次拉取平台。请先在「产品合规 → 合规资料」完成平台同步，再回到首页刷新。": "Pull TikTok data on the home compliance to-do only recounts data already stored locally. Sync Product compliance → Compliance records first, then refresh the home page.",
  "首页「合规资质待办」的「拉取 SHEIN 后台数据」只重算本地已入库数据，不会再次拉取平台。请先在「产品合规 / 合规资料」完成平台同步，再回到首页刷新。": "Pull SHEIN data on the home compliance to-do only recounts data already stored locally. Sync Product compliance / Compliance records first, then refresh the home page.",
  "首页「合规资质待办」的「拉取 TEMU 后台数据」只重算本地已入库数据，不会再次拉取平台。请先在「合规资质 → 合规信息 / 实拍图」完成平台同步，再回到首页刷新。": "Pull TEMU data on the home compliance to-do only recounts data already stored locally. Sync Compliance → Compliance info / Live photos first, then refresh the home page.",
  "证书缺失 / 即将过期如何处理？": "How do I handle missing or expiring certificates?",
  "进入「产品合规 → 证书绑定」，按筛选上传或绑定证书。即将过期可在「即将过期」筛选项中集中处理。": "Open Product compliance → Certificate binding, then upload or bind certificates. Use the Expiring soon filter to handle them together.",
  "进入「合规资质 → 产品证书资质」，在产品行点「详情/编辑」：先 queryNeedUploadItems 查待传项，再 uploadProductCert 提交；也可从证书库选已有证书绑定。": "Open Compliance → Product certificates, then Details/Edit on the product row. Load the items that still need upload, submit them, or bind a certificate from the library.",
  "实拍图 / 标签待补在哪里处理？": "Where do I complete live photos or labels?",
  "实拍图待补在哪里处理？": "Where do I complete live photos?",
  "进入「产品合规 → 实拍图」。同步时把平台返回了实拍识别要求的 SKC 写入本地（待补充 / 审核中 / 审核通过都入库）；无要求的不落库。列表上方可按审核维度切换，列「审核状态」来自平台 reviewStatus。": "Open Product compliance → Live photos. Sync stores SKCs that the platform asked to photograph. Filter by review status. The status column comes from the platform reviewStatus.",
  "进入「合规资质 → 实拍图」。同步时把平台返回了实拍识别要求的 SKC 写入本地（待补充 / 审核中 / 审核通过都入库）；无要求的不落库。列表上方可按资料状态维度切换。": "Open Compliance → Live photos. Sync stores SKCs that the platform asked to photograph. Filter the list by material status.",
  "代理（欧代 / 英代 / 美代）如何绑定？": "How do I bind an EU, UK, or US representative?",
  "代理（欧代 / 英代 / 美代）状态在哪里看？": "Where do I see EU, UK, or US representative status?",
  "进入「产品合规 → 代理绑定」，选择未绑定 SKC 完成代理绑定。代理公司列表可在「合规资料 → 公司代理」查看；绑定前请先同步合规数据。": "Open Product compliance → Representative binding and bind unbound SKCs. Company representatives are under Compliance records → Company representative. Sync compliance data before binding.",
  "进入「合规资质 → 合规信息」，产品合规信息列中的「责任人/代理」展示绑定状态；请先「拉取 TEMU 后台数据」同步合规缓存。": "Open Compliance → Compliance info. The responsible person / representative column shows the binding status. Pull TEMU data first to refresh the cache.",
  "财务账单同步不到数据？": "Finance bills are not syncing?",
  "确认店铺类型（自运营 / 半托管）与账单类型（对账单 / 报告）选择正确，并使用合理的时间范围同步。超长区间请缩小后再试。": "Check the shop type and bill type, then sync a reasonable date range. Narrow the range if it is too long.",
  "退货单列表为空或详情不全？": "The return list is empty or the detail is incomplete?",
  "先在「订单管理 > 退货退款」页按时间范围「拉取 TikTok 后台数据」。详情优先读本地缓存；若仍不全，可在详情页刷新以强制拉取平台。": "On Orders > Returns, pull TikTok data for a date range. Details read the local cache first. Refresh the detail page to force a platform fetch.",
  "先在「订单管理 > 退货退款」页按时间范围「拉取 SHEIN 后台数据」。详情优先读本地缓存；若仍不全，可在详情页刷新以强制拉取平台。": "On Orders > Returns, pull SHEIN data for a date range. Details read the local cache first. Refresh the detail page to force a platform fetch.",
  "先在「订单管理 > 退货退款」页按时间范围「拉取 TEMU 后台数据」。详情优先读本地缓存；若仍不全，可在详情页刷新以强制拉取平台。": "On Orders > Returns, pull TEMU data for a date range. Details read the local cache first. Refresh the detail page to force a platform fetch.",
  "平台通知和系统通知有什么区别？": "What is the difference between platform notices and system notices?",
  "平台通知侧重核价、平台推送等业务提醒；系统通知侧重店铺授权、同步异常等。打开对应铃铛后，推送与同步类会记为已读并去掉角标，业务待办会一直留在角标里直到事项处理完。单条也可点 × 关闭；完整列表与常见问题请打开「帮助」。": "Platform notices cover pricing and platform alerts. System notices cover authorization and sync errors. Opening a bell marks pushes and sync items as read. Business to-dos stay on the badge until they are finished. You can dismiss one item, or open Help for the full list and FAQ.",
  "遇到无法自行解决的问题如何反馈？": "How do I report a problem I cannot resolve?",
  "在本帮助页切换到「问题反馈」，填写联系邮箱与问题描述后提交。反馈会发送到系统已配置的收件邮箱；请尽量附上店铺名、操作路径与大致时间，便于排查。": "Open the Feedback tab on this help page, enter an email and a description, then submit. Include the shop name, the page you used, and the approximate time.",
  "排队等待调用平台…": "Waiting in queue to call the platform…",
  "准备刊登失败": "Failed to prepare the listing",
  "请先在规格供应中选择尺码，再填写尺寸信息": "Select sizes in specifications before filling the size chart",
  "尺码表存在空的尺码名称，请检查后再提交": "The size chart has an empty size name. Check it before submitting",
  "：请全部尺码填完，或整列留空（不可只填部分尺码）": ": fill every size, or leave the whole column empty",
  "套装类目请选择至少": "For a set category, select at least",
  "个尺码表模板": "size chart templates",
  "请选择至少一个尺码表模板": "Select at least one size chart template",
  "尺码表第": "Size chart row",
  "行请填写尺码名称": "needs a size name",
  "行请填写": "needs",
  "请至少填写一项尺寸测量值": "Enter at least one measurement",
  "请完善尺码表": "Complete the size chart",
  "尺码表图片缺少可上传地址，请在产品模板中重新上传尺码图": "The size chart image has no upload URL. Upload it again in the product template",
  "尺码表图片未转成平台 uri，请重试": "The size chart image was not converted to a platform URI. Try again",
  "找不到产品模板关联的尺码表": "No size chart is linked to this product template",
  "尺码表未生成平台模板，请在产品模板中填写尺码或上传尺码图": "No platform size chart was created. Fill sizes or upload a size chart image in the product template",
  "确定类目": "Choose a category",
  "站点仓运费": "Site, warehouse and freight",
  "属性与规格": "Attributes and variants",
  "图片视频": "Images and video",
  "确认发布": "Confirm and publish",
  "返回商品列表": "Back to products",
  "（可跳过）": "(can skip)",
  "（非必填）": "(optional)",
  "清除选中": "Clear selection",
  "恢复": "Restoring",
  "进度…": "progress…",
  "正在启动": "Starting",
  "已终止": "Stopped",
  "已等待": "waited",
  "排队中…": "Queued…",
  "（大时间段可能较久，请勿重复点击）": "(a long range can take a while, do not click again)",
  "（请求仍在进行，进度约 92% 为等待上限，请勿重复点击）": "(the request is still running; 92% is the waiting cap, do not click again)",
  "同步核价单后，按已启用规则自动处理「待供应商确认」单据：可按「建议价÷申报价」比例，或按建议价绝对金额设置拒绝/同意阈值；中间区间仍需人工处理。": "After pricing sheets sync, enabled rules handle sheets waiting for the supplier. Set reject or accept thresholds by suggested/declared ratio or by a fixed amount. The middle range still needs a person.",
  "从 TikTok 后台拉取核价单，更新到 IPE 本地。": "Pull pricing sheets from TikTok and update the local copy.",
  "从 TEMU 后台拉取核价单，更新到 IPE 本地。": "Pull pricing sheets from TEMU and update the local copy.",
  "从 SHEIN 后台拉取议价单，更新到 IPE 本地。": "Pull bargain sheets from SHEIN and update the local copy.",
  "请填写商品名称": "Enter a product name",
  "商品名称至少 2 个字符": "The product name must be at least 2 characters",
  "请先选择店铺": "Select a shop first",
  "请选择商品类目": "Select a category",
  "当前类目缺少商品类型，请重新选择末级类目": "This category has no product type. Choose a leaf category again",
  "请选择上架站点": "Select a listing site",
  "当前店铺为多仓，请选择库存所在仓库": "This shop uses multiple warehouses. Select the stock warehouse",
  "请填写产品标题": "Enter a product title",
  "产品标题至少 2 个字符": "The product title must be at least 2 characters",
  "产品标题不能超过 150 个字符": "The product title cannot exceed 150 characters",
  "产品标题不能包含中文，请改为英文后再推送": "The product title cannot contain Chinese. Use English before publishing",
  "请选择标题语言": "Select the title language",
  "请填写商家货号": "Enter the seller SKU",
  "请填写货号（本土发品 externalGoodsId 必填）": "Enter the SKU (externalGoodsId is required for local listing)",
  "请至少上传 1 张商品主图": "Upload at least 1 main image",
  "请为每个 SKU 填写大于 0 的售价/供货价": "Enter a price greater than 0 for every SKU",
  "请至少配置 1 个 SKU": "Add at least 1 SKU",
  "当前店铺类型未知，无法按全托/半托规则发品，请重新授权或同步店铺资料": "The shop type is unknown. Authorize again or sync the shop before publishing",
  "当前店铺类型未知，无法按发品规则提交，请重新授权或同步店铺资料": "The shop type is unknown. Authorize again or sync the shop before submitting",
  "英文名称尚未生成，请稍候自动翻译完成后再提交": "The English name is not ready. Wait for translation, then submit",
  "英文名称不能包含中文，请重新触发翻译": "The English name cannot contain Chinese. Translate it again",
  "半托管英文名称过短，请完善后再提交": "The English name is too short. Complete it before submitting",
  "请选择产地（二字码）": "Select the country of origin",
  "全托管发品请选择制造地点": "Select the manufacturing location",
  "全托管且产地非中国大陆时请上传产地证明文件": "Upload an origin certificate when the origin is outside mainland China",
  "请选择外包装形状": "Select the outer package shape",
  "外包装形状不合法，请选择长方体 / 圆柱体 / 其他不规则形状": "Choose a cuboid, cylinder, or irregular outer package shape",
  "请选择外包装类型": "Select the outer package type",
  "外包装类型不合法，请选择硬包装 / 软包装+硬物 / 软包装+软物": "Choose hard packaging, soft packaging with hard goods, or soft packaging with soft goods",
  "请上传外包装图片（1–6 张，须含正拍/侧拍/俯拍，且完成 Temu 转图）": "Upload 1–6 outer package photos, including front, side, and top, after Temu conversion",
  "外包装图片建议至少 3 张（正拍图、侧拍图、俯拍图）": "Use at least 3 outer package photos: front, side, and top",
  "当前类目要求上传电子说明书（PDF）": "This category requires a PDF manual",
  "半托管发品请选择运费模板": "Select a freight template",
  "半托管发品请选择库存仓库": "Select the stock warehouse",
  "当前类目要求填写模特信息，请选择模特": "This category requires a model. Select one",
  "主图视频未完成 Temu 上传，请重新上传": "The main video was not uploaded to Temu. Upload it again",
  "主图视频未取得平台 vid，请重新上传": "The main video has no platform vid. Upload it again",
  "商品名称须为英文，不能包含中文": "The product name must be English and cannot contain Chinese",
  "请填写商品描述（TikTok Create Product 必填，支持 HTML）": "Enter a product description (required for TikTok Create Product, HTML allowed)",
  "商品描述须为英文，不能包含中文": "The description must be English and cannot contain Chinese",
  "请选择商品类目（叶子类目 category_id）": "Select a leaf category",
  "缺少售价币种：请等待店铺币种加载完成": "The price currency is missing. Wait for the shop currency to load",
  "请选择库存仓库（inventory.warehouse_id）": "Select the inventory warehouse",
  "请上传商品主图（须完成 TikTok 平台转图）": "Upload a main image after TikTok conversion",
  "请填写包裹重量（单位 g）": "Enter the package weight in grams",
  "包裹重量须为大于 0 的数字（单位 g）": "Package weight must be a number greater than 0, in grams",
  "请填写包裹尺寸（长/宽/高，单位 cm，正整数）": "Enter package length, width, and height in centimeters as positive integers",
  "包裹尺寸须为正整数（单位 cm）": "Package dimensions must be positive integers, in centimeters",
  "主图视频未完成 TikTok 上传（需要 video.id），请重新上传": "The main video was not uploaded to TikTok. Upload it again",
  "已选择预约上架，请填写上架时间": "Scheduled listing is on. Enter the listing time",
  "预约上架时间无效，请重新选择日期时间": "The scheduled listing time is invalid. Choose it again",
  "预约上架时间须晚于当前时间": "The scheduled listing time must be in the future",
  "单次限购须为大于 0 的整数": "The per-order limit must be an integer greater than 0",
  "累计限购须为大于 0 的整数": "The cumulative limit must be an integer greater than 0",
  "累计限购数量不能小于单次限购数量": "The cumulative limit cannot be lower than the per-order limit",
  "请填写预售上架时间": "Enter the pre-sale listing time",
  "请填写预售发货时长（大于 0 的整数天）": "Enter the pre-sale handling time as a whole number of days greater than 0",
  "上架方式无效，请选择自动上架或定时上架": "Choose automatic listing or scheduled listing",
  "定时上架请选择期望上架时间": "Choose the expected listing time for scheduled listing",
  "期望上架时间格式须为 yyyy-MM-dd HH:mm:ss": "The listing time must use yyyy-MM-dd HH:mm:ss",
  "商家货号仅支持字母、数字、中文、下划线、短横线、加号，最长 100 位": "The seller SKU can use letters, digits, Chinese, underscore, hyphen, and plus, up to 100 characters",
  "请选择工艺类型（单一/组合）": "Select single or combined technology",
  "请选择一级工艺": "Select a primary technology",
  "当前工艺类型下不可选该一级工艺": "That primary technology is not available for this type",
  "基础工艺无需选择二级工艺": "Basic technology does not need a secondary technology",
  "单一工艺请选择且仅选择 1 项二级工艺": "Single technology needs exactly 1 secondary technology",
  "组合工艺请至少选择 2 项二级工艺": "Combined technology needs at least 2 secondary technologies",
  "一级工艺": "Primary technology",
  "二级工艺": "Secondary technology",
  "基础工艺": "Basic technology",
  "木制品定制工艺": "Wood customization",
  "金属制品定制工艺": "Metal customization",
  "皮具/布艺定制工艺": "Leather or fabric customization",
  "有机材料（亚克力/树脂等）定制工艺": "Organic material customization (acrylic, resin, and similar)",
  "画布/纸张定制工艺": "Canvas or paper customization",
  "激光雕刻-文字": "Laser engraving, text",
  "激光雕刻-图片": "Laser engraving, image",
  "机械雕刻-文字": "Mechanical engraving, text",
  "机械雕刻-图片": "Mechanical engraving, image",
  "焊接": "Welding",
  "蚀刻": "Etching",
  "丝网印刷-文字": "Screen printing, text",
  "丝网印刷-图片": "Screen printing, image",
  "喷漆": "Spray paint",
  "滴油": "Oil drip",
  "滴胶-文字": "Resin drip, text",
  "滴胶-图片": "Resin drip, image",
  "激光切割-文字": "Laser cutting, text",
  "激光切割-图片": "Laser cutting, image",
  "镶钻": "Stone setting",
  "烫金-文字": "Foil stamping, text",
  "烫金-图片": "Foil stamping, image",
  "锡金": "Tin gilding",
  "热转印-文字": "Heat transfer, text",
  "热转印-图片": "Heat transfer, image",
  "刺绣": "Embroidery",
  "植绒": "Flocking",
  "电镀": "Electroplating",
  "烫画-文字": "Heat-press print, text",
  "烫画-图片": "Heat-press print, image",
  "数码直喷": "Digital direct print",
  "压印": "Embossing",
  "美甲手绘": "Nail art, hand painted",
  "机织图案-胶贴": "Woven pattern, adhesive patch",
  "烫钻": "Rhinestone heat transfer",
  "手绘": "Hand painted",
  "水转印印刷": "Water transfer printing",
  "烤漆": "Baked paint",
  "3D打印": "3D printing",
  "男上装": "Men's tops",
  "男下装": "Men's bottoms",
  "女上装": "Women's tops",
  "女下装": "Women's bottoms",
  "女连衣裙": "Women's dresses",
  "女童装": "Girls' clothing",
  "文胸": "Bras",
  "男鞋": "Men's shoes",
  "女鞋": "Women's shoes",
  "女童鞋": "Girls' shoes",
  "鞋子": "Shoes",
  "男套装": "Men's sets",
  "女套装": "Women's sets",
  "男女套装": "Unisex sets",
  "女上装-大码": "Women's tops, plus",
  "女下装-大码": "Women's bottoms, plus",
  "女连衣裙-大码": "Women's dresses, plus",
  "女套装-大码": "Women's sets, plus",
  "宠物配饰": "Pet accessories",
  "女袜": "Women's socks",
  "男袜": "Men's socks",
  "童袜": "Kids' socks",
  "女士短裙-常规": "Women's skirts, regular",
  "女士外套-常规": "Women's outerwear, regular",
  "女士连体裤-常规": "Women's jumpsuits, regular",
  "女士紧身衣-常规": "Women's bodysuits, regular",
  "女士内裤-常规": "Women's underwear, regular",
  "女士连身泳衣-常规": "Women's one-piece swimwear, regular",
  "女士塑身衣-常规": "Women's shapewear, regular",
  "女士短裙-大码": "Women's skirts, plus",
  "女士外套-大码": "Women's outerwear, plus",
  "女士连体裤-大码": "Women's jumpsuits, plus",
  "女士紧身衣-大码": "Women's bodysuits, plus",
  "女士内裤-大码": "Women's underwear, plus",
  "女士连身泳衣-大码": "Women's one-piece swimwear, plus",
  "女士塑身衣-大码": "Women's shapewear, plus",
  "男士外套": "Men's outerwear",
  "男士连体裤": "Men's jumpsuits",
  "男士内裤": "Men's underwear",
  "男下装-前后浪选填款": "Men's bottoms, optional rise",
  "男上装-大码": "Men's tops, plus",
  "男下装-大码": "Men's bottoms, plus",
  "男上装（背心）-大码": "Men's tank tops, plus",
  "男套装-大码": "Men's sets, plus",
  "猫狗服饰": "Cat and dog clothing",
  "猫狗鞋袜": "Cat and dog shoes and socks",
  "上装-中性": "Tops, unisex",
  "下装-中性": "Bottoms, unisex",
  "连体裤-中性": "Jumpsuits, unisex",
  "孕妇上装": "Maternity tops",
  "孕妇下装": "Maternity bottoms",
  "孕妇背心": "Maternity tanks",
  "孕妇连衣裙": "Maternity dresses",
  "孕妇套装": "Maternity sets",
  "大码男装内衣下装": "Plus men's underwear bottoms",
  "大码男装内裤": "Plus men's underwear",
  "男士大码内衣套装": "Plus men's underwear sets",
  "唐装汉服男上装": "Men's tang suit / hanfu tops",
  "唐装汉服男下装": "Men's tang suit / hanfu bottoms",
  "唐装汉服男其它": "Men's tang suit / hanfu, other",
  "唐装汉服男套装": "Men's tang suit / hanfu sets",
  "唐装汉服童其它": "Kids' tang suit / hanfu, other",
  "唐装汉服女童套装": "Girls' tang suit / hanfu sets",
  "腰带": "Belts",
  "情趣男连体衣": "Men's bodysuits",
  "情趣男下装": "Men's bottoms",
  "唐装汉服大码男下装": "Plus men's tang suit / hanfu bottoms",
  "其他大码男传统服装": "Other plus men's traditional clothing",
  "唐装汉服大码男套装": "Plus men's tang suit / hanfu sets",
  "女童装-下装": "Girls' bottoms",
  "女童装-上装": "Girls' tops",
  "女童装套装": "Girls' sets",
  "男上装（背心）": "Men's tank tops",
  "女童装-连体衣": "Girls' bodysuits",
  "女童装-马甲": "Girls' vests",
  "女童装-半身裙": "Girls' skirts",
  "女童装-连衣裙": "Girls' dresses",
  "床笠": "Fitted sheets",
  "被套组": "Duvet cover sets",
  "床单组": "Sheet sets",
  "枕套组": "Pillowcase sets",
  "羽绒被/厚被": "Duvets / thick quilts",
  "薄被/床盖": "Thin quilts / coverlets",
  "男内调节码": "Men's adjustable underwear",
  "床单床笠四件套": "Sheet and fitted-sheet four-piece sets",
  "羽绒被套三件套": "Duvet three-piece sets",
  "薄被三件套": "Thin-quilt three-piece sets",
  "厚被三件套": "Thick-quilt three-piece sets",
  "男童鞋": "Boys' shoes",
  "男-裙子": "Men's skirts",
  "连裤袜": "Tights",
  "孕妇半身裙": "Maternity skirts",
  "男-牛仔": "Men's denim",
  "大码孕妇-上装": "Plus maternity tops",
  "大码孕妇-下装": "Plus maternity bottoms",
  "大码孕妇背心": "Plus maternity tanks",
  "大码孕妇内裤": "Plus maternity underwear",
  "大码孕妇连衣裙": "Plus maternity dresses",
  "大码孕妇半身裙": "Plus maternity skirts",
  "大码孕妇连体衣": "Plus maternity bodysuits",
  "大码孕妇套装": "Plus maternity sets",
  "孕妇内裤": "Maternity underwear",
  "孕妇连体衣": "Maternity bodysuits",
  "孕妇连体裤": "Maternity jumpsuits",
  "大码孕妇连体裤": "Plus maternity jumpsuits",
  "男童装": "Boys' clothing",
  "唐装汉服童其它-男": "Boys' tang suit / hanfu, other",
  "男童装-下装": "Boys' bottoms",
  "男童装-上装": "Boys' tops",
  "男童装-连体衣": "Boys' bodysuits",
  "男童装-马甲": "Boys' vests",
  "唐装汉服男童套装": "Boys' tang suit / hanfu sets",
  "男童装套装": "Boys' sets",
  "男上装（衬衫）": "Men's shirts",
  "床上用品": "Bedding",
  "吊袜带、吊袜腰带": "Garter belts",
  "挂毯、壁毯": "Tapestries",
  "女士情趣配件": "Women's accessories",
  "收腹带": "Waist trainers",
  "车罩": "Car covers",
  "运动鞋鞋带尺码模板": "Sneaker lace size template",
  "枕头枕芯": "Pillows and inserts",
  "被子类": "Quilts",
  "床笠2": "Fitted sheets 2",
  "床单、被套类": "Sheets and duvet covers",
  "窗帘类": "Curtains",
  "男士内衣睡衣": "Men's underwear and sleepwear",
  "男士塑身衣": "Men's shapewear",
  "宠物床具": "Pet beds",
  "浴袍毛巾": "Robes and towels",
  "服饰": "Apparel",
  "隐形文胸": "Adhesive bras",
  "枕头、枕芯": "Pillows and inserts",
  "配饰-腰带": "Accessories, belts",
  "运动腰带": "Sport belts",
  "被套套装": "Duvet cover sets",
  "二级工艺 20028": "Secondary technology 20028",
  "二级工艺 20029": "Secondary technology 20029",
  "二级工艺 20030": "Secondary technology 20030",
  "二级工艺 20031": "Secondary technology 20031",
  "二级工艺 20032": "Secondary technology 20032",
  "SKU 数量不能超过 {0}（当前 {1}）": "SKU count cannot exceed {0} (current {1})",
  "{0} ~ {1} 折": "{0}–{1}% of price",
  "{0} 填写口径": "{0} entry mode",
  "{0} 查询": "Search {0}",
  "{0} 比例合计须为 100%": "{0} percentages must total 100%",
  "{0} 活动件数": "{0} activity quantity",
  "{0} 活动预留件数": "{0} reserved quantity",
  "{0}，支持逗号批量": "{0}, commas allowed for bulk entry",
  "{0}：比例须为大于 0 的数字": "{0}: the percentage must be greater than 0",
  "{0}：请选择成分项": "{0}: select a component",
  "…共 {0} 个 SKU": "…{0} SKUs in total",
  "≤ {0} 折": "≤ {0}% of price",
  "≥ {0} 折": "≥ {0}% of price",
  "「{0} / {1}」供货价须为大于 0 的数字": "Supply price for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」净含量单位无效": "Net content unit for \"{0} / {1}\" is invalid",
  "「{0} / {1}」净含量须为正整数": "Net content for \"{0} / {1}\" must be a positive integer",
  "「{0} / {1}」划线价不能超过 {2}": "List price for \"{0} / {1}\" cannot exceed {2}",
  "「{0} / {1}」划线价须为大于 0 的数字": "List price for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」划线价（list_price）不能低于售价": "List price for \"{0} / {1}\" cannot be lower than the sale price",
  "「{0} / {1}」包装件数须为正整数": "Package quantity for \"{0} / {1}\" must be a positive integer",
  "「{0} / {1}」包装体积须为大于 0 的数字（单位 cm）": "Package volume for \"{0} / {1}\" must be greater than 0, in cm",
  "「{0} / {1}」包装尺寸须为大于 0 的数字": "Package size for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」包装清单数量之和（{2}）须等于单品数量（{3}）": "Packing-list quantities for \"{0} / {1}\" ({2}) must equal the item quantity ({3})",
  "「{0} / {1}」包装类型无效": "Package type for \"{0} / {1}\" is invalid",
  "「{0} / {1}」包装重量须为大于 0 的数字": "Package weight for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」包装重量须为大于 0 的数字（单位 g）": "Package weight for \"{0} / {1}\" must be greater than 0, in grams",
  "「{0} / {1}」单品数量须为正整数": "Item quantity for \"{0} / {1}\" must be a positive integer",
  "「{0} / {1}」同款多件/混合套装须选择是否独立包装": "Select whether \"{0} / {1}\" is individually packed",
  "「{0} / {1}」售价须为大于 0 的数字": "Sale price for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」商品条码格式无效（支持 GTIN/EAN/UPC/ISBN/JAN）": "Barcode for \"{0} / {1}\" is invalid (GTIN/EAN/UPC/ISBN/JAN)",
  "「{0} / {1}」已选敏感，请至少选择一种敏感类型": "\"{0} / {1}\" is marked sensitive. Select at least one sensitive type",
  "「{0} / {1}」库存不能超过 {2}": "Stock for \"{0} / {1}\" cannot exceed {2}",
  "「{0} / {1}」库存至少为 {2}（平台 inventory.quantity 不允许 0）": "Stock for \"{0} / {1}\" must be at least {2}",
  "「{0} / {1}」库存须为 ≥0 的整数": "Stock for \"{0} / {1}\" must be an integer of 0 or more",
  "「{0} / {1}」库存须为整数": "Stock for \"{0} / {1}\" must be an integer",
  "「{0} / {1}」建议零售价须为大于 0 的数字": "Suggested retail price for \"{0} / {1}\" must be greater than 0",
  "「{0} / {1}」混合套装须填写包装清单": "A mixed set for \"{0} / {1}\" needs a packing list",
  "「{0} / {1}」请选择 SKU 分类": "Select an SKU category for \"{0} / {1}\"",
  "「{0} / {1}」请选择净含量单位": "Select a net content unit for \"{0} / {1}\"",
  "「{0} / {1}」请选择包装单位（件/双/包）": "Select a package unit for \"{0} / {1}\" (piece, pair, or pack)",
  "「{0} / {1}」请选择包装单位（件/双/套）": "Select a package unit for \"{0} / {1}\" (piece, pair, or set)",
  "「{0} / {1}」请选择单件单位（件/双/包）": "Select a unit for \"{0} / {1}\" (piece, pair, or pack)",
  "「{0} / {1}」货品净重须为大于 0 的数字（单位 g）": "Net weight for \"{0} / {1}\" must be greater than 0, in grams",
  "「{0}」SKU 缺少{1}，请重新勾选{2}": "SKU \"{0}\" is missing {1}. Select {2} again",
  "「{0}」变体图缺少平台 uri（不能只用 CDN 链接）。请重新本地上传或从图片空间选用，完成平台转图后再发品": "Variant image for \"{0}\" has no platform URI. Upload it again before publishing",
  "「{0}」同一颜色下各尺码申报价须一致": "Declared prices for \"{0}\" must match across sizes",
  "「{0}」同规格下包装单位须保持一致（件/双/套）": "Package units for \"{0}\" must be the same across SKUs",
  "「{0}」商品图（主图+细节图）至少 {1} 张，当前 {2} 张": "\"{0}\" needs at least {1} images (current {2})",
  "「{0}」已为部分 SKU 上传 SKU 图，部分编辑要求同规格下全部 SKU 都提交 SKU 图": "Some SKUs of \"{0}\" have images. This edit requires an image for every SKU",
  "「{0}」已填写部分 SKU 包装件数，同规格下全部 SKU 都须填写件数": "Some SKUs of \"{0}\" have a package quantity. Every SKU needs one",
  "「{0}」的{1}未匹配到平台属性值，请在模板中重新选择颜色": "{1} for \"{0}\" does not match a platform value. Choose the color again",
  "「{0}」第 {1} 张细节图无效，请重新上传": "Detail image {1} for \"{0}\" is invalid. Upload it again",
  "「{0}」细节图最多 10 张": "\"{0}\" can have at most 10 detail images",
  "「{0}」细节图最多 {1} 张": "\"{0}\" can have at most {1} detail images",
  "「{0}」缺少 SKU 供应信息，请选择{1}或检查规格": "\"{0}\" is missing SKU supply info. Select {1} or check the variants",
  "「{0}」缺少{1}属性，请刷新类目属性模板后重试": "\"{0}\" is missing {1}. Refresh the attribute template and try again",
  "「{0}」货号仅支持字母、数字、中文、下划线、短横线、加号，最长 100 位": "SKU \"{0}\" can use letters, digits, Chinese, underscore, hyphen, and plus, up to 100 characters",
  "上传未返回 objectKey/url": "Upload did not return a file address",
  "以下 SKC 已在报名任务中，请勿重复提交：{0}{1}": "These SKCs are already enrolling. Do not submit them again: {0}{1}",
  "保存产品模板失败": "Could not save the product template",
  "其他规格": "Other variant",
  "删除本条": "Remove this item",
  "剩余 {0}": "{0} left",
  "加载可报商品失败": "Could not load products available for enrollment",
  "加载核价单失败": "Could not load pricing sheets",
  "加载议价单失败": "Could not load bargain sheets",
  "卖家": "Seller",
  "可报商品分页": "Enrollable products pages",
  "同意 {0}": "Accepted {0}",
  "同意后将按平台建议价确认核价单。": "Accepting confirms the sheet at the platform suggested price.",
  "同意后将提交 confirmInfos（discussAuditType=1），商品价格变为平台建议价。": "Accepting submits confirmInfos (discussAuditType=1) and the price becomes the platform suggestion.",
  "商品主图（main_images）最多 {0} 张，当前去重后 {1} 张，请删减后再提交": "At most {0} main images are allowed. {1} remain after dedupe. Remove some before submitting",
  "商品卖点合计不能超过 {0} 个字符（当前 {1}）": "Selling points cannot exceed {0} characters (current {1})",
  "商品卖点最多 {0} 条（当前 {1}）": "At most {0} selling points (current {1})",
  "商品名称不能超过 {0} 个字符": "The product name cannot exceed {0} characters",
  "商品名称至少 {0} 个字符": "The product name must be at least {0} characters",
  "商品描述不能超过 {0} 个字符": "The description cannot exceed {0} characters",
  "商品描述中的图片不能超过 30 张，当前 {0} 张": "The description can include at most 30 images (current {0})",
  "商品条码「{0}」重复，每个 SKU 的 identifier_code 须唯一": "Barcode \"{0}\" is duplicated. Each SKU identifier must be unique",
  "处理失败": "Could not process",
  "处理成功 {0} 单": "Processed {0}",
  "处理核价单失败": "Could not process the pricing sheet",
  "处理议价单失败": "Could not process the bargain sheet",
  "套用属性库失败": "Could not apply the attribute template",
  "对应 externalLinkList，选填，最多 5 个（竞品/材料说明等 URL）": "Optional external links, up to 5 URLs",
  "已上传 {0} 个文件": "Uploaded {0} files",
  "已保存到产品模板": "Saved to the product template",
  "已创建产品模板": "Product template created",
  "已处理 {0} 单{1}": "Processed {0}{1}",
  "已导出 {0} 条": "Exported {0}",
  "已批量填写（{0} 个 SKC）": "Filled {0} SKCs",
  "已批量应用到全部 SKU": "Applied to all SKUs",
  "已按尺码批量应用到各颜色的对应尺码行": "Applied to the matching size of each color",
  "已提交": "Submitted",
  "已提交后台报名（{0} 个 SKC），可继续报名其它商品": "Enrollment submitted for {0} SKCs. You can enroll other products",
  "已跳过 {0} 个进行中的 SKC，将提交其余 {1} 个": "Skipped {0} SKCs already enrolling. The other {1} will be submitted",
  "平台详情暂时拉取失败，当前展示的是本地缓存的活动信息。": "The platform detail could not be loaded. Showing the cached activity.",
  "当前为自运营店铺，成本议价单不适用。请从侧栏进入「价格处理 → 建议零售价」。": "Cost bargain sheets do not apply to this self-operated shop. Open Price handling, then Suggested retail price.",
  "当前为自运营店铺，核价单不适用。请从侧栏进入「价格处理 → 调价单」。": "Pricing sheets do not apply to this self-operated shop. Open Price handling, then Price adjustments.",
  "当前市场（{0}）不支持预售类型「{1}」": "Market {0} does not support pre-sale type \"{1}\"",
  "当前店铺不可报名该活动": "This shop cannot enroll in the activity",
  "当前活动不可报名": "This activity is not open for enrollment",
  "当前类目不支持预售类型「{0}」，请改选其它类型或留空": "This category does not support pre-sale type \"{0}\". Choose another type or leave it empty",
  "当前类目要求填写「{0} / {1}」SKU 分类": "This category requires an SKU category for \"{0} / {1}\"",
  "当前类目要求填写「{0} / {1}」净含量（计量含量，不是货品净重）": "This category requires net content for \"{0} / {1}\" (not net weight)",
  "当前类目要求填写「{0} / {1}」货品净重（单位 g）": "This category requires net weight in grams for \"{0} / {1}\"",
  "必填，最多 20 条；请选择原因类型并填写说明": "Required, up to 20. Choose a reason type and add a note",
  "打开发品页失败": "Could not open the publish page",
  "批量填写{0}": "Bulk fill {0}",
  "批量处理失败": "Bulk processing failed",
  "批量查询 SKC": "Bulk search SKC",
  "批量查询 {0}": "Bulk search {0}",
  "批量查询产品ID": "Bulk search product ID",
  "批量查询核价单号": "Bulk search pricing sheet no.",
  "批量查询议价单号": "Bulk search bargain sheet no.",
  "批量查询货号": "Bulk search seller SKU",
  "承诺发货时效不符合当前站点（{0}）可选值，请重新选择": "The handling time is not available for site {0}. Choose it again",
  "折扣百分比": "Discount percent",
  "报名失败": "Enrollment failed",
  "报名数据校验未通过": "Enrollment data did not pass validation",
  "拒绝 {0}": "Rejected {0}",
  "拒绝后将提交 confirmInfos（discussAuditType=2），议价单结束且无法再报价上架。": "Rejecting submits confirmInfos (discussAuditType=2). The bargain ends and cannot be quoted again.",
  "拒绝后核价单将按平台规则结束或进入重新报价。": "Rejecting ends the sheet or opens a new quote, following platform rules.",
  "拒绝议价": "Reject quote",
  "搜索词合计不能超过 {0} 个字符（当前 {1}）": "Search terms cannot exceed {0} characters (current {1})",
  "搜索词最多 {0} 个（当前 {1}）": "At most {0} search terms (current {1})",
  "改价原因：{0}": "Price change reason: {0}",
  "日常价": "Everyday price",
  "未返回报名任务 ID，请稍后重试": "No enrollment task ID was returned. Try again later",
  "松开上传图片": "Release to upload images",
  "核价单": "Pricing sheet",
  "核价单 {0}": "Pricing sheet {0}",
  "模特「{0}」缺少试穿尺码规格 ID，请重新选择试穿尺码": "Model \"{0}\" is missing a try-on size ID. Choose the size again",
  "模特「{0}」试穿尺码「{1}」不在当前商品已选尺码中": "Try-on size \"{1}\" for model \"{0}\" is not among the selected sizes",
  "模特「{0}」试穿尺码无效（不可为均码），请从商品已选尺码中选择": "Try-on size for model \"{0}\" is invalid. Choose one of the selected sizes",
  "正在查询核价单…": "Loading pricing sheets…",
  "正在查询议价单…": "Loading bargain sheets…",
  "每行一个 {0}，或用逗号分隔": "One {0} per line, or separate with commas",
  "每行一个产品ID，或用逗号分隔": "One product ID per line, or separate with commas",
  "每行一个商家货号，或用逗号分隔": "One seller SKU per line, or separate with commas",
  "每行一个平台 SKC，或用逗号分隔": "One platform SKC per line, or separate with commas",
  "每行一个核价单号，或用逗号分隔": "One pricing sheet number per line, or separate with commas",
  "每行一个议价单号，或用逗号分隔": "One bargain sheet number per line, or separate with commas",
  "每行一条，或用逗号分隔": "One item per line, or separate with commas",
  "活动 {0}": "Activity {0}",
  "活动价必须小于{0}": "The activity price must be lower than the {0}",
  "活动价格 / 折扣": "Activity price / discount",
  "活动报名 · SHEIN": "Activity enrollment · SHEIN",
  "活动详情暂不可用，当前仅展示本地活动列表信息，请稍后重试或先同步活动列表。": "Activity details are unavailable. Showing the local activity list. Retry later or sync the list.",
  "点击或拖拽上传辅助材料": "Click or drop supporting files",
  "确认同意": "Confirm accept",
  "确认同意核价单「{0}」的平台建议价？": "Accept the platform price for pricing sheet \"{0}\"?",
  "确认同意议价单「{0}」的平台建议价？将提交 confirmInfos（discussAuditType=1）。": "Accept the platform price for bargain sheet \"{0}\"? This submits confirmInfos (discussAuditType=1).",
  "确认拒绝": "Confirm reject",
  "确认拒绝核价单「{0}」？": "Reject pricing sheet \"{0}\"?",
  "确认拒绝议价单「{0}」？将提交 confirmInfos（discussAuditType=2），拒绝后无法再报价上架。": "Reject bargain sheet \"{0}\"? This submits confirmInfos (discussAuditType=2) and the item cannot be quoted again.",
  "确认提交": "Submit",
  "第 {0} 张细节图无效，请重新上传": "Detail image {0} is invalid. Upload it again",
  "第 {0} 张细节图缺少平台 uri，请重新选用并完成平台转图": "Detail image {0} has no platform URI. Choose it again",
  "第 {0} 轮": "Round {0}",
  "细节图最多 {0} 张（主图+细节合计不超过 {1} 张）": "At most {0} detail images (main plus detail cannot exceed {1})",
  "缺少叶子类目 catId，无法加载类目属性": "A leaf category is required before attributes can load",
  "自动规则已执行：{0}{1}": "Auto rules ran: {0}{1}",
  "自动规则执行失败": "Auto rules failed",
  "英文名称自动翻译失败": "Could not translate the English name",
  "议价商品": "Bargain product",
  "该属性库商品类型与当前类目不一致，已取消套用": "This attribute template does not match the current category, so it was not applied",
  "该属性库属于类目 {0}，与当前类目 {1} 不一致，已取消套用。请选用当前类目下的属性库": "This attribute template belongs to category {0}, not {1}, so it was not applied",
  "请为「{0}」上传主图（需符合平台图片规则）": "Upload a main image for \"{0}\"",
  "请为「{0}」上传主图（须完成 Temu 平台转图）": "Upload a main image for \"{0}\" after Temu conversion",
  "请为「{0}」上传变体图（须完成 TikTok 平台转图）": "Upload a variant image for \"{0}\" after TikTok conversion",
  "请先输入{0}": "Enter {0} first",
  "请填写「{0} / {1}」供货价": "Enter the supply price for \"{0} / {1}\"",
  "请填写「{0} / {1}」包装件数": "Enter the package quantity for \"{0} / {1}\"",
  "请填写「{0} / {1}」包装体积（最长边/次长边/最短边，单位 cm）": "Enter package length, width, and height in cm for \"{0} / {1}\"",
  "请填写「{0} / {1}」包装尺寸（长×宽×高）": "Enter package length, width, and height for \"{0} / {1}\"",
  "请填写「{0} / {1}」包装重量": "Enter the package weight for \"{0} / {1}\"",
  "请填写「{0} / {1}」包装重量（单位 g）": "Enter the package weight in grams for \"{0} / {1}\"",
  "请填写「{0} / {1}」单品数量": "Enter the item quantity for \"{0} / {1}\"",
  "请填写「{0} / {1}」售价": "Enter the sale price for \"{0} / {1}\"",
  "请填写「{0} / {1}」库存": "Enter the stock for \"{0} / {1}\"",
  "请填写「{0}」货号": "Enter the SKU for \"{0}\"",
  "请填写关键属性：{0}": "Fill required attribute: {0}",
  "请填写必填属性：{0}": "Fill required attribute: {0}",
  "请添加{0}": "Add {0}",
  "请至少上传 {0} 张商品主图（须完成 TikTok 图片上传）": "Upload at least {0} main images after TikTok conversion",
  "请至少填写一项：{0}": "Fill at least one: {0}",
  "请至少填写必填属性：{0}": "Fill at least one required attribute: {0}",
  "请选择{0}": "Select {0}",
  "请选择「{0} / {1}」包装类型": "Select a package type for \"{0} / {1}\"",
  "请选择关键属性：{0}": "Select required attribute: {0}",
  "请选择必填属性：{0}": "Select required attribute: {0}",
  "请选择或自定义{0}": "Select or enter {0}",
  "调整后价格": "Adjusted price",
  "货号（external_product_id）最长 {0} 位": "The SKU can be at most {0} characters",
  "运营": "Operations",
  "选择 {0}": "Select {0}",
  "重新报价": "Quote again",
  "预售上架时间须在当前起 {0}–{1} 天内": "The pre-sale listing time must be {0}–{1} days from now",
  "预售发货时长须为 {0}–{1} 天": "Pre-sale handling time must be {0}–{1} days",
  "预约上架时间不能超过 {0} 天": "The scheduled listing time cannot be more than {0} days out",
  "（不可用）": " (unavailable)",
  "（默认）": " (default)",
  "示例卫衣 · 待核价": "Sample hoodie · awaiting review",
  "示例连衣裙 · 待供应商确认": "Sample dress · awaiting supplier",
  "示例休闲裤 · 核价通过": "Sample pants · pricing approved",
  "示例外套 · 核价驳回": "Sample coat · pricing rejected",
  "示例T恤 · 待调价": "Sample T-shirt · awaiting price change",
  "示例卫衣 · 待供应商确认": "Sample hoodie · awaiting supplier",
  "示例短裤 · 调价成功": "Sample shorts · price updated",
  "示例外套 · 调价失败": "Sample coat · price update failed",
  "日常价调整示例": "Sample everyday price change",
  "活动价下调，请确认": "Activity price decrease, please confirm",
  "活动调价": "Activity price change",
  "价格低于活动底价": "Price is below the activity floor",
  "供应商": "Supplier",
  "，": ", ",
  "，失败 {0}": ", {0} failed",
  "，成功 {0}": ", {0} succeeded",
  "操作过于频繁，请 {0} 秒后再试": "Too many attempts. Try again in {0} seconds",
  "分类 {0}": "Category {0}",
  "未命名类目": "Unnamed category",
  "上架站点": "Listing sites",
  "操作失败，请稍后重试": "The action failed. Try again later",
  "请求的资源不存在": "The requested resource was not found",
  "请求方式不允许，请稍后重试": "This request is not allowed. Try again later",
  "操作过于频繁，请稍后再试": "Too many attempts. Try again later",
  "请先登录后再使用此功能": "Sign in before using this feature",
  "暂无权限执行此操作": "You do not have permission for this action",
  "服务器繁忙，请稍后再试": "The server is busy. Try again later",

  // 本地商品库 · 自动化列
  "预处理": "Preprocessing",
  "AI文案": "AI copy",
  "视频生成": "Video generation",
  "侵权检测": "Infringement check",
  "刊登任务": "Listing job",
  "刊登失败": "Listing failed",
  "正在转换图片和视频": "Converting images and videos",
  "刊登任务已创建": "Listing job created",
  "已跳过": "Skipped",
  "准备中…": "Preparing…",
  "预处理完成，准备刊登…": "Preprocessing done, preparing to list…",
  "刊登任务 {0}/{1}": "Listing job {0}/{1}",
  "已完成": "Completed",
  "执行失败": "Failed",
  "已绑定规则，待执行": "Rule bound, waiting to run",
  "已加入排队": "Queued",
  "刊登前校验未通过": "Pre-listing validation failed",
  "刊登前校验未通过：{0}": "Pre-listing validation failed: {0}",
  "用户已终止自动化": "User stopped automation",
  "商户已停止自动化": "Merchant stopped automation",
  "已加入定时上架": "Added to scheduled listing",
  "已加入定时上架，等待 {0}": "Added to scheduled listing, waiting until {0}",
  "已加入定时上架（同批次 {0} 个 SPU 同任务）":
    "Added to scheduled listing ({0} SPUs in the same job for this batch)",
  "已加入间隔上架，每隔 {0} 分钟发布 1 个入库批次":
    "Added to interval listing: publish 1 inbound batch every {0} minute(s)",
  "已加入间隔上架，每隔 {0} 分钟发布 1 个入库批次（同批次 {1} 个 SPU 同任务）":
    "Added to interval listing: publish 1 inbound batch every {0} minute(s) ({1} SPUs in the same job for this batch)",
  "已加入间隔上架，自 {0} 起每隔 {1} 分钟发布 1 个入库批次（同批次 {2} 个 SPU 同任务）":
    "Added to interval listing: from {0}, publish 1 inbound batch every {1} minute(s) ({2} SPUs in the same job for this batch)",
  "自动化跳过：{0}": "Automation skipped: {0}",
  "自动化执行失败：{0}": "Automation failed: {0}",
  "自动化执行失败": "Automation failed",
  "自动化异常中断，已自动结束": "Automation interrupted and ended automatically",
  "批次数据无效": "Batch data is invalid",
  "批次缺少所有者": "Batch has no owner",
  "批次未绑定自动规则": "Batch is not bound to an auto rule",
  "所选规则不存在或未启用": "Selected rule is missing or disabled",
  "规则未开启任何预处理或上架模块": "Rule has no preprocessing or listing modules enabled",
  "刊登任务已创建，部分步骤失败：{0}":
    "Listing job created; some steps failed: {0}",
  "创建刊登任务失败（未返回任务 ID）": "Failed to create listing job (no job id returned)",
  "数据库行锁等待超时，请稍后对该批次重试自动化":
    "Database row lock timed out. Retry automation for this batch later",

  // --- merged TikTok i18n ---
  "关闭": "Close",
  "取消": "Cancel",
  "产品ID": "Product ID",
  "状态": "Status",
  "加载中…": "Loading…",
  "模板名称": "Template name",
  "自动规则": "Auto rule",
  "保存中…": "Saving…",
  "请选择": "Please select",
  "操作": "Actions",
  "查询": "Search",
  "可选": "Optional",
  "款号": "Style no.",
  "备注": "Note",
  "复制失败": "Copy failed",
  "保存": "Save",
  "请填写模板名称": "Enter a template name",
  "优先级": "Priority",
  "已复制": "Copied",
  "商品": "Product",
  "建议零售价": "Suggested retail price",
  "提交中…": "Submitting…",
  "请填写款号": "Enter a style no.",
  "货号": "Item no.",
  "移除": "Remove",
  "预览": "Preview",
  "类目": "Category",
  "请输入款号": "Enter a style no.",
  "暂无可发商品分类": "No publishable categories",
  "产品信息": "Product info",
  "适用类目": "Applicable categories",
  "站点": "Site",
  "批量查询": "Batch search",
  "名称": "Name",
  "尺寸": "Size",
  "已开始下载": "Download started",
  "暂无数据": "No data",
  "店铺信息": "Shop info",
  "模特": "Model",
  "请先选择已授权的 TikTok 店铺": "Select an authorized TikTok shop first",
  "请选择类目": "Select a category",
  "暂无可导出数据": "Nothing to export",
  "是": "Yes",
  "否": "No",
  "尺码": "Size",
  "尺寸信息": "Size info",
  "平台 JSON": "Platform JSON",
  "半托管": "Semi-managed",
  "订单": "Order",
  "运单号": "Tracking no.",
  "币种": "Currency",
  "活动名称": "Campaign name",
  "不限": "Any",
  "主规格": "Main spec",
  "活动场次": "Campaign session",
  "类型": "Type",
  "更新时间": "Updated",
  "请先选择 TikTok 店铺": "Select a TikTok shop first",
  "请先选择规格尺码": "Select a size first",
  "点击上传": "Click to upload",
  "上传中…": "Uploading…",
  "近 7 天": "Last 7 days",
  "开始": "Start",
  "结束": "End",
  "运费模板": "Shipping template",
  "物流商": "Carrier",
  "证书类型": "Certificate type",
  "证书文件": "Certificate file",
  "时间": "Time",
  "审核状态": "Review status",
  "标题": "Title",
  "说明": "Description",
  "暂无场次": "No sessions",
  "站点 ID": "Site ID",
  "商品 ID": "Product ID",
  "自主报名": "Self enroll",
  "请先勾选数据": "Select rows first",
  "编辑": "Edit",
  "数量": "Qty",
  "全选": "Select all",
  "请至少选择一张图片": "Select at least one image",
  "所选图片无效或已失效，请重试": "Selected images are invalid or expired. Try again",
  "侵权检测结果": "Infringement check result",
  "批量填写商品条码": "Batch fill barcodes",
  "按尺码填写": "Fill by size",
  "上传类型": "Upload type",
  "正在加载尺码表": "Loading size chart",
  "店铺类型": "Shop type",
  "请先勾选要导出的数据": "Select rows to export first",
  "如：女装夏季基础属性": "e.g. Women’s summer base attributes",
  "正在加载模板…": "Loading template…",
  "请先选择店铺类型": "Select a shop type first",
  "测量类型": "Measurement type",
  "单位制": "Unit system",
  "暂无数据可导出": "Nothing to export",
  "店铺": "Shop",
  "当前店铺正在同步中，请等待同步完成后可操作": "This shop is syncing. Wait until it finishes",
  "售价": "Sale price",
  "适用范围": "Scope",
  "合规资料": "Compliance materials",
  "全部": "All",
  "影响站点": "Affected sites",
  "规则无效": "Invalid rule",
  "自动规则已保存": "Auto rule saved",
  "批量输入 SKC": "Batch enter SKCs",
  "商家货号，支持批量": "Seller SKU, batch supported",
  "批量输入货号": "Batch enter item nos.",
  "来源": "Source",
  "分类": "Category",
  "按供货价折扣": "Discount off supply price",
  "按统一报价": "Flat quote",
  "活动时间": "Campaign time",
  "持续天数": "Duration (days)",
  "场次状态": "Session status",
  "报名状态": "Enrollment status",
  "报名向导": "Enrollment wizard",
  "报名步骤": "Enrollment steps",
  "全选当前页场次": "Select all sessions on this page",
  "加载场次中…": "Loading sessions…",
  "已按当前活动与所选货品查询场次列表。": "Sessions loaded for the current campaign and selected products.",
  "全选当前页站点": "Select all sites on this page",
  "站点名称": "Site name",
  "暂无可选站点": "No sites available",
  "请先选择具体店铺": "Select a specific shop first",
  "件数": "Units",
  "备货发货": "Stock & ship",
  "打印中心": "Print center",
  "包装合规": "Packaging compliance",
  "商品广告": "Product ads",
  "销量数据": "Sales data",
  "加载详情中…": "Loading details…",
  "是否可报名": "Can enroll",
  "报名方式": "Enrollment method",
  "暂无详情": "No details",
  "优惠": "Discount",
  "已用": "Used",
  "活动库存": "Campaign stock",
  "活动里还没有商品": "No products in this campaign yet",
  "加载活动商品中…": "Loading campaign products…",
  "展示": "Display",
  "活动报名": "Campaign enrollment",
  "更多": "More",
  "供货价": "Supply price",
  "活动状态": "Campaign status",
  "报名截止": "Enrollment deadline",
  "直接折扣": "Direct discount",
  "固定价格": "Fixed price",
  "秒杀": "Flash sale",
  "运费折扣": "Shipping discount",
  "创建中…": "Creating…",
  "创建": "Create",
  "单号": "Order no.",
  "申请新增属性值": "Request new attribute value",
  "属性值": "Attribute value",
  "长": "Length",
  "宽": "Width",
  "高": "Height",
  "重量": "Weight",
  "SKU 分类": "SKU category",
  "单品数量": "Units per SKU",
  "共计内含": "Total contents",
  "独立包装": "Individual packaging",
  "是否敏感": "Sensitive item",
  "批量填写": "Batch fill",
  "请先选择规格颜色与尺码": "Select color and size first",
  "可先填一套模板再同步到各尺码": "Fill one template first, then sync to each size",
  "裁剪中": "Cropping",
  "产品尺寸信息": "Product size info",
  "选择尺码库": "Select size chart library",
  "共用": "Shared",
  "SKU 明细": "SKU details",
  "商家 SKU": "Seller SKU",
  "价格": "Price",
  "正在查询建议零售价填写规则…": "Loading suggested retail price rules…",
  "分站点建议零售价": "Per-site suggested retail price",
  "本站无需证明材料": "No proof required for this site",
  "其他站点建议零售价（不分站点汇总）": "Suggested retail price for other sites (aggregated)",
  "其他站点无需证明材料": "No proof required for other sites",
  "检测状态：": "Check status:",
  "检测时间：": "Checked at:",
  "暂无详细检测说明": "No detailed check notes",
  "将应用到当前所有 SKU 行": "Will apply to all current SKU rows",
  "默认填写": "Default fill",
  "条码类型": "Barcode type",
  "商品条码": "Product barcode",
  "同一条码将写入当前所有颜色 / 尺码 SKU": "The same barcode will be written to all color/size SKUs",
  "暂无已选尺码": "No sizes selected",
  "同一尺码下的各颜色 SKU 共用该条码；未填的尺码不改动": "SKUs of the same size share this barcode; blank sizes are left unchanged",
  "颜色编码": "Color code",
  "暂无已选颜色": "No colors selected",
  "图案编号": "Pattern no.",
  "在商家 SKU 添加图案编号": "Append pattern no. to seller SKU",
  "视频": "Video",
  "批量填写商家 SKU": "Batch fill seller SKUs",
  "当前": "Current",
  "最新": "Latest",
  "注册商号": "Registered business name",
  "邮箱": "Email",
  "国家码": "Country code",
  "本地号码": "Local number",
  "地址": "Address",
  "有效期": "Valid until",
  "请选择日期时间": "Select date and time",
  "清空": "Clear",
  "仅支持上传 PDF": "PDF only",
  "说明书文件需在 50MB 以内": "Guide file must be under 50MB",
  "正在查询该类目是否必须上传说明书…": "Checking whether this category requires a guide file…",
  "更新说明书文件": "Update guide file",
  "补充或修改【安装/使用说明】和【安全信息说明】": "Add or edit installation/usage and safety instructions",
  "说明书来源": "Guide source",
  "说明书尽可能覆盖更多语言，可有效提升转化并降低客诉。": "Cover more languages in the guide to improve conversion and reduce complaints.",
  "图片预览": "Image preview",
  "请先选择类目": "Select a category first",
  "请先选择参考店铺以加载尺码表填写规则": "Select a reference shop to load size-chart rules",
  "该类目无需填写尺码表。": "This category does not need a size chart.",
  "正在拉取测量项与尺码库，请稍候…": "Loading measurements and size charts…",
  "创建尺码表": "Create size chart",
  "上传图片": "Upload image",
  "请先选择店铺后再上传尺码表图片。": "Select a shop before uploading a size-chart image.",
  "从尺码库选用（可选）": "Pick from size-chart library (optional)",
  "请从上方尺码表库选择": "Select from the size-chart library above",
  "点击预览大图": "Click to preview",
  "搜索": "Search",
  "仓库": "Warehouse",
  "上一步": "Back",
  "品牌 ID": "Brand ID",
  "品牌名称": "Brand name",
  "可发类目": "Publishable categories",
  "店铺名称": "Shop name",
  "授权状态": "Auth status",
  "选择要同步的店铺": "Select shops to sync",
  "拉取 TikTok 后台数据": "Pull TikTok Seller Center data",
  "基本信息": "Basic info",
  "已删除": "Deleted",
  "模板名称，支持模糊": "Template name (fuzzy search)",
  "请至少上传一个证书文件": "Upload at least one certificate file",
  "文件名称": "File name",
  "展示用文件名": "Display file name",
  "已上传证书文件": "Certificate file uploaded",
  "该类目缺少 product_type_id，无法查询属性，请换一个末级类目": "This category has no product_type_id; pick another leaf category",
  "类目属性尚未加载完成，请稍后再保存": "Category attributes are still loading. Save later",
  "当前类目暂无可填属性": "No fillable attributes for this category",
  "请先填写类目属性再保存到属性库": "Fill category attributes before saving to the attribute library",
  "保存到官方属性库": "Save to official attribute library",
  "保存到属性库": "Save to attribute library",
  "保存产品模板": "Save product template",
  "保存到官方尺码库": "Save to official size-chart library",
  "保存为尺码模板": "Save as size-chart template",
  "确认测量参数": "Confirm measurements",
  "未绑定类目：按已有结构化内容编辑；保存后建议同步以回填类目。": "No category bound: edit existing structured content; sync after save to backfill category.",
  "正在加载类目尺码规则…": "Loading category size-chart rules…",
  "该类目不支持尺码表（平台 is_supported=false）。": "This category does not support size charts (is_supported=false).",
  "已选均码，不可再选其它尺码；清除后可多选。": "One-size is selected; clear it before selecting other sizes.",

  // --- merged TikTok i18n ---
  "批量填写价格": "Fill prices",
  "批量填写建议零售价": "Fill suggested retail price",
  "批量填写库存": "Fill stock",
  "如 9.99": "e.g. 9.99",
  "如 19.99": "e.g. 19.99",
  "如 100": "e.g. 100",
  "如 SPU-COLOR-SIZE（最长 {0}，无空格）": "e.g. SPU-COLOR-SIZE (max {0}, no spaces)",
  "素材图要求：{0}。仅可上传 1 张。": "Material image: {0}. Upload 1 only.",
  "商品图（主图+细节图，至少 {0} 张、合计不超过 {1} 张）：{2}。同一商品只填一组，不按颜色分图。": "Product images (main + details, at least {0}, max {1} total): {2}. One set per product, not per color.",
  "变体图（sku_img）：按颜色维护，展示该规格在选项画廊中的样子。{0}。按平台口径以 use_case=ATTRIBUTE_IMAGE 上传。": "Variant image (sku_img): maintain per color for the option gallery. {0}. Upload with use_case=ATTRIBUTE_IMAGE.",

  // --- merged TikTok i18n ---
  "{0}%～{1}% 人工": "{0}%–{1}% manual",
  "{0}～{1}元 人工": "{0}–{1} CNY manual",
  "{0}同步完成": "{0} sync completed",
  "<{0}% 拒绝": "<{0}% reject",
  "<{0}元 拒绝": "<{0} CNY reject",
  "≥{0}% 同意": "≥{0}% accept",
  "≥{0}元 同意": "≥{0} CNY accept",
  "按「建议价 ÷ 申报价」比例判断。例：申报 20、建议 10 → 50%。同步核价单后自动执行启用中的规则。": "By ratio (suggested ÷ declared). E.g. declared 20, suggested 10 → 50%. Runs after discuss sync for enabled rules.",
  "按比例": "By ratio",
  "按价格": "By price",
  "按平台建议价（元）判断：低于拒绝价自动拒绝，达到同意价自动同意；中间需人工处理。同步核价单后自动执行启用中的规则。": "By platform suggested price (CNY): below reject → auto reject; at/above accept → auto accept; in between → manual. Runs after discuss sync for enabled rules.",
  "比例": "Ratio",
  "不可处理": "Not actionable",
  "草稿": "Draft",
  "从 TikTok 后台拉取{0}，更新到 IPE 本地。": "Pull {0} from TikTok into IPE.",
  "从 TikTok 拉取包装合规套装属性。": "Pull packaging compliance kit attributes.",
  "从 TikTok 拉取产品销量数据。": "Pull product sales metrics from TikTok.",
  "从 TikTok 拉取发货单/箱唛缓存；可对发货单号请求打印。": "Pull delivery orders / box labels from TikTok; request print by delivery SN.",
  "从 TikTok 拉取发货台与备货采购单，更新到 IPE 本地。": "Pull fulfillment desk and stock POs from TikTok into IPE.",
  "从 TikTok 拉取寄样单到本地。": "Pull sample orders from TikTok locally.",
  "从 TikTok 拉取可报名活动列表、详情与场次，更新到 IPE 本地。": "Pull enrollable campaigns, details, and sessions from TikTok into IPE.",
  "从 TikTok 拉取全托广告计划。": "Pull full-service ad plans from TikTok.",
  "从 TikTok 拉取退供包裹本地缓存。": "Pull return packages into local cache.",
  "从 TikTok 拉取质检单本地缓存。": "Pull QC bills into local cache.",
  "打印": "Print",
  "打印接口已调用，请查看返回结果": "Print API called; check the response",
  "打印失败": "Print failed",
  "打印已提交": "Print submitted",
  "当前 access_token 未授权该接口。请到 TikTok 卖家中心勾选对应 API 权限并重新授权。": "This access_token lacks API scope. Enable the API in Seller Center and re-authorize.",
  "导出数据": "Export data",
  "发送到系统邮箱": "Send to system inbox",
  "发送中…": "Sending…",
  "加载{0}失败": "Failed to load {0}",
  "加载通知失败": "Failed to load notifications",
  "拒绝": "Reject",
  "类目加载中…": "Loading categories…",
  "买X送Y": "Buy X get Y",
  "满减优惠": "Buy more save more",
  "没有匹配的通知": "No matching notifications",
  "平台终止": "Terminated by platform",
  "清除失败": "Failed to dismiss",
  "商家 ID": "Merchant ID",
  "尚未同步{0}": "{0} not synced yet",
  "提交后将直接发送到系统已配置的收件邮箱。下方联系邮箱用于我们回复进度；紧急授权/同步问题也可先查看「常见问题」。": "Submissions go to the configured system inbox. Use your email for replies; for urgent auth/sync issues, check FAQ first.",
  "提交失败": "Submit failed",
  "添加": "Add",
  "同步时间：{0}": "Synced at: {0}",
  "同意": "Accept",
  "完成(清除)": "Done (dismiss)",
  "未开始": "Not started",
  "已打开打印页（{0} 单）": "Opened print page ({0} orders)",
  "已获取 dataKey：{0}": "Got dataKey: {0}",
  "已结束": "Ended",
  "已授权": "Authorized",
  "已停用": "Deactivated",
  "暂无{0}": "No {0}",
  "暂无通知": "No notifications yet",
  "正在查询{0}…": "Loading {0}…",
  "正在启动{0}…": "Starting {0}…",
  "终止同步失败": "Failed to cancel sync",
  "access_token 无效（7000020）。常见原因：token 填错、已失效/被撤销、或未用卖家中心重新授权。请到 TikTok 卖家中心重新授权并更新店铺密钥后再同步。": "access_token invalid (7000020). Token may be wrong, revoked, or stale. Re-authorize in Seller Center and update credentials before syncing again.",
  "access_token 已过期（7000007）。请到 TikTok 卖家中心重新授权，并在平台管理更新店铺 Token；「授权过期时间」可作为是否过期的依据。": "access_token expired (7000007). Re-authorize in TikTok Seller Center and update the shop token in platform admin; use “Token expiry” as reference.",
  "正在加载物流商": "Loading carriers…",
  "平台优惠": "Platform discount",
  "履约方式": "Fulfillment method",
  "配送选项": "Delivery option",
  "配送类型": "Delivery type",
  "货到付款": "Cash on delivery",
  "样品单": "Sample order",
  "拆合包": "Split / combine",
  "合包": "Combined",
  "拆包": "Split",
  "支付方式": "Payment method",
  "买家留言": "Buyer message",
  "卖家备注": "Seller note",
  "取消原因": "Cancellation reason",
  "取消发起方": "Cancelled by",
  "买家": "Buyer",
  "系统": "System",
  "发货时间": "Shipped at",
  "状态更新时间": "Status updated at",
  "最晚发货时间": "Ship-by deadline",
  "最晚揽收时间": "Handover deadline",
  "自动取消时间": "Auto-cancel time",
  "要求送达时间": "Required delivery time",
  "揽收时间": "Collected at",
  "送达时间": "Delivered at",
  "支付币种": "Payment currency",
  "商品原价": "Original product price",
  "商品小计": "Product subtotal",
  "支付渠道折扣": "Payment channel discount",
  "运费原价": "Original shipping fee",
  "运费卖家折扣": "Shipping seller discount",
  "运费平台折扣": "Shipping platform discount",
  "税费": "Tax",
  "商品税": "Product tax",
  "运费税": "Shipping tax",
  "零售配送费": "Retail delivery fee",
  "手续费": "Handling fee",
  "收件人": "Recipient",
  "电话": "Phone",
  "详细地址": "Street address",
  "投放位置": "Drop-off location",
  "区/县": "District",
  "卖家自发货": "Seller fulfillment",
  "TikTok 履约": "Fulfilled by TikTok",
  "Tokopedia 履约": "Fulfilled by Tokopedia",
  "送货上门": "Home delivery",
  "自提点": "Collection point",
  "现货": "In stock",
  "预售": "Pre-order",
  "按单生产": "Made to order",
  "缺货预订": "Back order",
  "虚拟商品": "Virtual product",
  "直播抽奖": "Live lottery",
  "拍卖": "Auction",
  "半托管/自运营": "Semi-hosted / self-operated",
  "全托管/POP": "Fully hosted / POP",
  "未知店铺类型": "Unknown shop type",
  "预计打款": "Estimated payout",
  "结算完成": "Settlement completed",
  "打款": "Payout",
  "缺失证书编码": "Missing certificate code",
  "缺失证书名称": "Missing certificate name",
  "待补充": "Needs supplement",
  "审核通过": "Approved",
  "绑定产品": "Linked products",
  "证书编号": "Certificate ID",
  "平台更新": "Platform updated",
  "请填写{0}": "Please fill in {0}",
  "资质证书": "Qualification certificate",
  "合规信息": "Compliance information",
  "卖点证书": "Selling-point certificate",
  "说明书": "User manual",
  "欧代": "EU representative",
  "英代": "UK representative",
  "美代": "US representative",
  "生产制造商": "Manufacturer",
  "欧洲代理": "European agent",
  "欧盟制造商": "EU manufacturer",
  "欧盟进口商": "EU importer",
  "欧盟配送服务提供商": "EU delivery service provider",
  "待审核(可绑)": "Pending review (bindable)",
  "申报成功": "Declaration successful",
  "审核失败": "Review failed",
  "生效中": "Active",
  "已过期": "Expired",
  "未生效": "Not yet effective",
  "全部商品": "All products",
  "部分商品": "Some products",
  "手动创建": "Created manually",
  "线上办理": "Online application",
  "待补全": "Incomplete",
  "已通过": "Approved",
  "已驳回": "Rejected",
  "待绑定": "Pending bind",
  "绑定失败": "Bind failed",
  "绑定成功": "Bind successful",
  "电话号码长度无效：本地号码须为数字，制造商 7–20 位、负责人 7–11 位": "Invalid phone number length: local number must be digits; 7–20 for manufacturer, 7–11 for responsible person",
  "邮箱格式无效": "Invalid email format",
  "地址长度无效": "Invalid address length",
  "名称长度无效": "Invalid name length",
  "电话国家码格式无效（须以 + 开头，最多 4 位数字）": "Invalid phone country code (must start with +, up to 4 digits)",
  "电话可用性取值无效（AVAILABLE / UNAVAILABLE）": "Invalid phone availability (AVAILABLE / UNAVAILABLE)",
  "制造商名称无效": "Invalid manufacturer name",
  "制造商地址无效": "Invalid manufacturer address",
  "注册商号无效": "Invalid registered trade name",
  "注册商号长度无效": "Invalid registered trade name length",
  "负责人姓名无效": "Invalid responsible person name",
  "负责人地址无效": "Invalid responsible person address",
  "国家须为欧盟国家二字码（如 IE、DE）": "Country must be an EU two-letter code (e.g. IE, DE)",
  "电话国家码须为欧盟区号（如 +353）": "Phone country code must be an EU code (e.g. +353)",
  "跨境全球卖家不支持此接口，仅欧盟本土店可用": "Cross-border global sellers are not supported; EU local shops only",
  "制造商数量已达上限": "Manufacturer limit reached",
  "负责人数量已达上限": "Responsible person limit reached",
  "创建失败": "Create failed",
  "待生成付款": "Payout pending generation",
  "即将付款": "Payout upcoming",
  "已付款": "Paid",
  "付款异常": "Payout exception",
  "待确认": "Pending confirmation",
  "待结算": "Pending settlement",
  "已结算": "Settled",
  "收入": "Income",
  "支出": "Expense",
  "直接打款": "Direct payout",
  "钱包充值": "Wallet top-up",
  "订单收入": "Order income",
  "订单退货": "Order return",
  "订单调整": "Order adjustment",
  "仓库退货": "Warehouse return",
  "丢货补款": "Lost goods reimbursement",
  "订单异常补款": "Order exception reimbursement",
  "订单异常扣款": "Order exception deduction",
  "银行打款验证": "Bank payout verification",
  "订单状态修正": "Order status correction",
  "订单履约服务费": "Order fulfillment service fee",
  "退货履约服务费": "Return fulfillment service fee",
  "订单履约服务费退还": "Order fulfillment fee refund",
  "履约服务费补款": "Fulfillment fee reimbursement",
  "履约服务费扣款": "Fulfillment fee deduction",
  "违规处罚补款": "Violation penalty reimbursement",
  "违规处罚扣款": "Violation penalty deduction",
  "平台激励补款": "Platform incentive reimbursement",
  "平台激励扣款": "Platform incentive deduction",
  "税费补款": "Tax reimbursement",
  "税费扣款": "Tax deduction",
  "备货作业费": "Stocking operation fee",
  "退货冻结差额补款": "Return freeze difference reimbursement",
  "退货冻结差额扣款": "Return freeze difference deduction",
  "退货丢货补款": "Return lost goods reimbursement",
  "取消订单补款": "Cancelled order reimbursement",
  "退货处理费": "Return processing fee",
  "GNRE税费补款": "GNRE tax reimbursement",
  "GNRE税费扣款": "GNRE tax deduction",
  "标准仓储费": "Standard storage fee",
  "超库龄附加仓储费": "Aged inventory storage surcharge",
  "交易申诉补款": "Transaction appeal reimbursement",
  "商家扣款单": "Seller chargeback",
  "库存盘亏": "Inventory shrinkage",
  "库存盘盈": "Inventory surplus",
  "仓储费补款": "Storage fee reimbursement",
  "仓储费扣款": "Storage fee deduction",
  "EPR补款": "EPR reimbursement",
  "EPR扣款": "EPR deduction",
  "SFS备货揽收费用": "SFS stocking pickup fee",
  "海外备货运费补款": "Overseas stocking freight reimbursement",
  "海外退供运费扣款": "Overseas return freight deduction",
  "仓储货物赔付补款": "Warehouse goods compensation",
  "仓储增值服务扣款": "Warehouse value-added service deduction",
  "商家合作押金补款": "Seller partnership deposit reimbursement",
  "定制化商家履约服务费补款": "Custom seller fulfillment fee reimbursement",
  "税费补贴": "Tax subsidy",
  "税费补贴退回": "Tax subsidy reversal",
  "其他应补款": "Other reimbursement",
  "其他应扣款": "Other deduction",
  "线下欠款回收": "Offline debt recovery",
  "运费补贴": "Shipping subsidy",
  "运费补贴退回": "Shipping subsidy reversal",
  "退货运费补贴": "Return shipping subsidy",
  "代收服务费": "Collection service fee",
  "违规处罚资金冻结": "Violation penalty fund freeze",
  "违规撤销资金解冻": "Violation reversal fund release",
  "履约服务费附加费": "Fulfillment service surcharge",
  "CA消费税补贴": "CA excise tax subsidy",
  "CA消费税补贴退回": "CA excise tax subsidy reversal",
  "DIFAL增值税扣款": "DIFAL VAT deduction",
  "客单正向成本调整": "Order forward cost adjustment",
  "客单逆向成本调整": "Order reverse cost adjustment",
  "客单结算": "Order settlement",
  "退货结算": "Return settlement",
  "支付手续费": "Payment processing fee",
  "SFS退供运费": "SFS return freight",
  "推客佣金补款": "Affiliate commission reimbursement",
  "推客佣金扣款": "Affiliate commission deduction",

  // --- merged TikTok i18n ---
  "AI 未返回商品描述": "AI did not return a product description",
  "AI 未返回标题": "AI did not return a title",
  "AI 未返回英文商品描述": "AI did not return an English product description",
  "AI 未返回英文标题": "AI did not return an English title",
  "SKU 缺少平台 sku id": "SKU is missing platform sku id",
  "TikTok Shop 不支持 update-cost，请使用 Update Price": "TikTok Shop does not support update-cost; use Update Price",
  "主图无法解析，请重新上传": "Main image could not be parsed; re-upload",
  "主图视频未完成 Tiktok 上传（缺少 vid/videoUrl），请重新上传后再发品": "Main video is not uploaded to TikTok yet (missing vid/videoUrl). Re-upload before publishing",
  "侵权检测任务创建失败": "Failed to create infringement check job",
  "商品主图缺少平台 uri（不能只用 CDN 链接）。请重新本地上传或从图片空间选用，完成平台转图后再发品": "Main image is missing platform uri (CDN URL alone is not enough). Re-upload or pick from image space after platform transfer",
  "商品名称须为英文；自动译英失败，请改为英文后重试": "Product title must be English; auto-translate failed. Switch to English and retry",
  "图片转换失败：未获得平台 uri，请重试": "Image conversion failed: no platform uri. Retry",
  "外包装形状不合法，请选择：长方体 / 圆柱体 / 其他不规则形状": "Invalid outer package shape. Choose: cuboid / cylinder / other irregular",
  "外包装类型不合法，请选择：硬包装 / 软包装+硬物 / 软包装+软物（不可选抽真空）": "Invalid outer package type. Choose: hard / soft+hard item / soft+soft item (no vacuum)",
  "已选外包装类型时请同时选择外包装形状": "When package type is set, also select package shape",
  "平台可复用尺码模板名称重复。请改从尺码库选用已有「平台」模板，或上传尺码表图片；填写尺寸发品已改为单品尺码，一般不会再撞名": "Reusable platform size-chart name conflicts. Pick an existing platform template from the library, or upload a size-chart image",
  "平台拒绝保存尺码表：请确认带 * 列已填，且肩宽/袖长等可选列不要只填一部分（空列会自动不传）": "Platform rejected the size chart: fill required (*) columns; do not partially fill optional columns like shoulder/sleeve (blank columns are omitted)",
  "平台未返回尺码表 ID": "Platform did not return a size-chart id",
  "当前类目要求尺码表：请填写下方尺寸参数、从尺码库选用，或上传尺码表图片（任选其一即可）": "This category requires a size chart: fill measurements below, pick from the library, or upload an image",
  "所选图片缺少可用地址": "Selected image has no usable URL",
  "无法上传图片到服务器": "Could not upload image to the server",
  "无法解析图片地址": "Could not parse image URL",
  "无法读取主图以生成素材图，请重新上传主图或手动上传素材图": "Could not read the main image to build a material image; re-upload main or upload material manually",
  "无法读取主图以生成色块图，请重新上传主图": "Could not read the main image to build a color swatch; re-upload main",
  "无法读取图片": "Could not read the image",
  "无法读取所选图片，请重试": "Could not read the selected image; retry",
  "未能创建自动绑定任务": "Failed to create auto-bind job",
  "本地存储空间不足，请清理后重试": "Not enough local storage; free space and retry",
  "本地尺码表没有尺寸行，无法提交平台": "Local size chart has no size rows; cannot submit",
  "本地尺码表缺少 sizeChartData，请先编辑完善后再提交": "Local size chart is missing sizeChartData; edit it before submitting",
  "本地尺码表缺少平台结构化内容，请打开编辑后重新保存再提交": "Local size chart is missing platform structure; open, re-save, then submit",
  "模特试穿尺码不可为均码，请从商品已选尺码中选择": "Model try-on size cannot be one-size; pick from selected product sizes",
  "模特试穿尺码无效，请从商品已选尺码中重新选择": "Model try-on size is invalid; pick again from selected product sizes",
  "没有价格变更": "No price changes",
  "没有可提交的变更。已审核 SKU 的售价/成本价请在提交时走专用改价接口；其余字段未改动。": "Nothing to submit. For reviewed SKU sale/cost prices use the dedicated price API; other fields are unchanged.",
  "编辑商品缺少平台 SPU，无法提交改品": "Editing product is missing platform SPU; cannot submit update",
  "缺少发品参数，无法调用平台核验": "Missing publish params; cannot run platform listing check",
  "缺少可检测的印花图": "No print image available for infringement check",
  "缺少商品 ID，无法 Update Price": "Missing product id; cannot Update Price",
  "缺少店铺": "Shop is missing",
  "缺少店铺或尺码表接口": "Shop or size-chart API is missing",
  "缺少类目，无法提交平台尺码表": "Category is missing; cannot submit platform size chart",
  "缺少颜色父规格 ID，请刷新类目属性模板后重试": "Missing color parent spec id; refresh category attribute template and retry",
  "自定义颜色名称不能为空，请重新选择颜色": "Custom color name cannot be empty; pick a color again",
  "草稿 ID 无效": "Invalid draft id",
  "该模板没有可提交的尺码表内容": "This template has no size-chart content to submit",
  "请上传素材图（1:1，边长≥800px）": "Upload a material image (1:1, side ≥ 800px)",
  "请上传素材图，或确保主图已上传以便自动裁成 1:1 素材图": "Upload a material image, or ensure the main image is uploaded so it can be cropped to 1:1",
  "请上传货品外包装图片（至少 1 张，须为 Tiktok 图址）": "Upload at least one outer-package image (TikTok image URI required)",
  "请为每个 SKU 填写商家 SKU（seller_sku）": "Enter seller_sku for every SKU",
  "请先为第一个颜色上传主图": "Upload a main image for the first color first",
  "请先为至少一个颜色上传主图": "Upload a main image for at least one color first",
  "请先选择叶子类目": "Select a leaf category first",
  "请先选择店铺后再生成素材图": "Select a shop before generating a material image",
  "请先选择店铺后再选择图片": "Select a shop before picking images",
  "请填写包装重量（克）": "Enter package weight (grams)",
  "请填写英文名称": "Enter an English name",
  "请完善货品外包装：选择外包装形状与类型": "Complete outer packaging: select shape and type",
  "请至少上传 1 张商品主图（须完成 TikTok 图片上传）": "Upload at least 1 main product image (after TikTok image upload)",
  "货品 ID 无效": "Invalid product id",

  // --- merged TikTok i18n ---
  "边长 300～4000px · 比例建议 3:4～4:3 · JPG/PNG/WEBP · ≤10MB（超出会压缩）": "300–4000px side length · 3:4–4:3 ratio recommended · JPG/PNG/WEBP · ≤10MB (compressed if larger)",
  "建议 1:1、边长≥800px（平台允许 300～4000）· JPG/PNG/WEBP · ≤10MB": "1:1 recommended, ≥800px side (300–4000 allowed) · JPG/PNG/WEBP · ≤10MB",
  "文件读取失败": "Failed to read file",
  "图片加载失败": "Failed to load image",
  "仅支持 JPG / PNG / WEBP / BMP 格式": "Only JPG / PNG / WEBP / BMP formats are supported",
  "单张图片不能超过 10MB": "Each image must be ≤10MB",
  "素材图尺寸不符合平台要求：须为正方形，边长 300～4000px": "Material image must be square, 300–4000px per side",
  "素材图尺寸不符合平台要求：须为 1:1": "Material image must be 1:1",
  "素材图过小：须边长≥{0}px（当前 {1}×{2}）": "Material image too small: side length ≥{0}px (current {1}×{2})",
  "素材图过大：须边长≤{0}px（当前 {1}×{2}）": "Material image too large: side length ≤{0}px (current {1}×{2})",
  "无法读取图片尺寸": "Unable to read image dimensions",
  "无法处理图片": "Unable to process image",
  "素材图压缩后仍超过 10MB，请换一张更小的图": "Material image still exceeds 10MB after compression; use a smaller file",
  "图片尺寸不符合平台要求：边长须为 300～4000px，比例建议 3:4～4:3": "Image must be 300–4000px per side; ratio 3:4–4:3 recommended",
  "图片过小：边长须≥{0}px（当前 {1}×{2}）": "Image too small: side length ≥{0}px (current {1}×{2})",
  "图片过大：边长须≤{0}px（当前 {1}×{2}）": "Image too large: side length ≤{0}px (current {1}×{2})",
  "图片比例不符合建议：须在 3:4～4:3 之间（超出后平台会自动拉成 1:1）": "Aspect ratio should be 3:4–4:3 (platform may crop to 1:1)",
  "无效图片": "Invalid image",
  "无法压缩图片": "Unable to compress image",
  "图片压缩后仍超过 10MB，请换一张更小的图": "Image still exceeds 10MB after compression; use a smaller file",
  "图片超过 10MB 且无法有效压缩，请换一张更小的图": "Image exceeds 10MB and cannot be compressed further",
  "无效主图": "Invalid main image",
  "无法读取主图尺寸": "Unable to read main image dimensions",
  "无法生成方块图": "Unable to generate square image",
  "方块图压缩后仍超过 10MB": "Square image still exceeds 10MB after compression",
  "无法生成色块图": "Unable to generate swatch image",
  "色块图生成失败": "Swatch image generation failed",
  "描述图片压缩后仍超过 10MB，请换一张更小的图": "Description image still exceeds 10MB after compression",
  "缺少商品类目": "Product category is required",
  "缺少商品类型，请重新选择末级类目": "Missing product type; re-select a leaf category",
  "类目属性加载失败": "Failed to load category attributes",
  "发布前校验未通过": "Pre-publish validation failed",
  "缺少店铺站点币种，请到店铺同步站点后再试": "Missing shop site currency; sync shop sites and retry",
  "缺少商品发布规范币种，请到店铺同步后再试": "Missing publish-standard currency; sync shop and retry",
  "表单校验未通过": "Form validation failed",
  "尺码表处理失败": "Size chart processing failed",
  "无法组装发布参数": "Unable to build publish payload",
  "平台发品核验未通过": "Platform listing check failed",
  "发品参数缺少售价币种（须来自店铺可售站点）": "Publish payload missing sale currency (from shop sites)",
  "发品参数缺少供货价币种（须来自商品发布规范）": "Publish payload missing supply currency (from publish standard)",
  "草稿#{0}": "Draft #{0}",
  "正在保存草稿「{0}」…": "Saving draft “{0}”…",
  "正在提交「{0}」…": "Submitting “{0}”…",
  "发布未成功": "Publish unsuccessful",
  "发布成功，商品已上架": "Published successfully; product is live",
  "正在校验 0/{0}…（规则 / 属性 / SKU）": "Validating 0/{0}… (rules / attributes / SKU)",
  "准备发布失败": "Failed to prepare publish",
  "校验通过 {0}/{1}：{2}": "Validation passed {0}/{1}: {2}",
  "校验失败 {0}/{1}：{2}": "Validation failed {0}/{1}: {2}",
  "校验完成，开始发布 0/{0}…": "Validation complete; publishing 0/{0}…",
  "全部未通过校验": "All items failed validation",
  "正在发布 {0}/{1}：{2}": "Publishing {0}/{1}: {2}",
  "正在发布 {0}/{1}": "Publishing {0}/{1}",
  "已发布 {0}/{1}：{2}": "Published {0}/{1}: {2}",
  "发布失败：{0}": "Publish failed: {0}",
  "请求失败": "Request failed",
  " · 半托管": " · Semi-managed",
  " · 全托/本土": " · Full-service / local",
  "发布成功": "Published successfully",
  " · 叶子": " · Leaf",
  "已选叶子类目 ID：{0}": "Selected leaf category ID: {0}",
  "店铺 #{0}": "Shop #{0}",
  "尺码表存在未填写的尺寸值：带 * 的必填；其它列请整列填完或整列留空后再提交": "Size chart has empty values: fill required (*) columns or leave optional columns blank",
  "平台未返回尺码表 ID，请稍后重试或改从尺码库选用模板": "Platform did not return size chart ID; retry or pick from library",
  "缺少尺码分类 classId": "Missing size chart classId",
  "属性 {0}": "Attribute {0}",
  "创建并选中": "Create and select",
  "请选择或搜索（可多选）": "Select or search (multi-select)",
  "暂不可选": "Not selectable",
  "待审核": "Pending review",
  "已上架": "Listed",
  "须为有效数字，不能填写文字或其它符号": "Must be a valid number; text or symbols not allowed",
  "不能为空": "Cannot be empty",
  "须为有效数字，不能填写文字": "Must be a valid number; text not allowed",
  "录入方式为单选，不允许录入多个值": "Single-select only; multiple values not allowed",
  "批量填写重量（g）": "Batch fill weight (g)",
  "批量填写体积（cm）": "Batch fill dimensions (cm)",
  "批量填写 SKU 分类": "Batch fill SKU classification",
  "批量填写包装类型": "Batch fill package type",
  "批量填写敏感属性": "Batch fill sensitive attributes",
  "批量填写包装清单": "Batch fill packing list",
  "硬包装": "Rigid packaging",
  "软包装+硬物": "Soft packaging + hard contents",
  "软包装+软物": "Soft packaging + soft contents",
  "抽真空": "Vacuum sealed",
  "没有可用的父规格可选": "No parent spec available",
  "未返回 specId": "specId not returned",
  "上传成功但未返回 Tiktok 图片 URL": "Upload succeeded but no TikTok image URL returned",
  "视频上传未返回可用结果": "Video upload returned no usable result",
  "创建尺码表未返回 businessId": "Create size chart did not return businessId",
  "面料": "Fabric",
  "面料重量": "Fabric weight",
  "面料纱织/密度": "Fabric yarn/density",
  "特征": "Features",
  "风格": "Style",
  "成分": "Composition",
  "填充物": "Filling",
  "护理说明": "Care instructions",
  "包含的组件": "Included components",
  "产品工艺": "Product technique",
  "领型": "Neckline",
  "袖长": "Sleeve length",
  "合身类型": "Fit type",
  "高度": "Height",
  "长度": "Length",
  "宽度": "Width",
  "周长": "Circumference",
  "直径": "Diameter",
  "款式": "Style type",
  "Excel 中没有工作表": "No worksheets in Excel file",
  "JSON 解析失败": "JSON parse failed",
  "JSON 解析失败，请确认文件格式": "JSON parse failed. Check the file format.",
  "\n…其余 {0} 项": "\n…and {0} more",
  "{0} 第 {1} 行缺少规格": "{0}: row {1} is missing size/spec",
  "{0}. {1}\n   当前：{2}\n   最新：{3}": "{0}. {1}\n   Current: {2}\n   Latest: {3}",
  "{0}分页": "{0} pagination",
  "{0}自动规则": "{0} auto-rule",
  "{0}（尺码 {1}）": "{0} (size {1})",
  "「{0}」第 {1} 行缺少属性ID": "\"{0}\" row {1} is missing attribute ID",
  "「{0}」第 {1} 行缺少规格": "\"{0}\" row {1} is missing size/spec",
  "不是受支持的素材模板导入文件": "Unsupported material template import file",
  "以下内容与模板库最新版本不一致，重新加载将用最新模板覆盖对应区域：": "The following differs from the latest template library version. Reloading will overwrite this area with the latest template:",
  "保存修改": "Save changes",
  "保存到尺码库失败": "Failed to save to size chart library",
  "保存到属性库失败": "Failed to save to attribute library",
  "保存到平台": "Save to platform",
  "保存前请确认测量类型与单位制（对应平台 Create Size Chart 的 measurement_type / unit_system）。": "Confirm measurement type and unit system before saving (maps to platform Create Size Chart measurement_type / unit_system).",
  "保存官方模板": "Save official template",
  "保存本地": "Save locally",
  "值": "Value",
  "全部视图下请选择一家店铺后再继续。": "In the all-shops view, select a shop to continue.",
  "全部视图下请选择目标店铺，再创建模板。": "In the all-shops view, select a target shop before creating a template.",
  "公制 (METRIC)": "Metric (METRIC)",
  "关键属性": "Key attributes",
  "创建到平台": "Create on platform",
  "删除{0}": "Delete {0}",
  "加载类目中…": "Loading categories…",
  "加载类目尺码规则失败": "Failed to load category size chart rules",
  "加载类目属性失败": "Failed to load category attributes",
  "单次最多导入 {0} 条，请拆分后重试": "Import at most {0} items at once. Split the file and retry.",
  "压缩包中没有 JSON 文件": "No JSON files in the archive",
  "同步平台尺码表库失败，将仅保存到站内尺码库": "Failed to sync platform size chart library; saved to site library only",
  "在此店新建": "Create in this shop",
  "均码": "One size",
  "复制中…": "Copying…",
  "复制到个人": "Copy to personal",
  "复制到此店": "Copy to this shop",
  "如：女装上衣基础尺码表": "e.g. Women's tops basic size chart",
  "如：女装基础尺码表": "e.g. Women's basic size chart",
  "如：女装夏季基础款": "e.g. Women's summer basic style",
  "官方尺码模板已保存（仅本地，未创建平台）": "Official size template saved locally (not created on platform)",
  "官方尺码模板已更新": "Official size template updated",
  "导入{0}": "Import {0}",
  "导入失败": "Import failed",
  "导入完成：成功 {0}，失败 {1}": "Import finished: {0} succeeded, {1} failed",
  "导出失败": "Export failed",
  "将导入 {0} 条到{1}。优先级会自动重算以避免冲突，模板名称保持文件中的原名。是否继续？": "Import {0} item(s) into {1}. Priority will be recalculated to avoid conflicts; template names stay as in the file. Continue?",
  "将当前填写的尺寸保存到站内尺码库（含款号与自动规则），下次可从下拉选用。发品页保存默认仅本地，不会提交到 TikTok 后台。": "Save current measurements to the site size library (style no. and auto-rule included) for reuse from the dropdown. Publish page saves locally by default and does not submit to TikTok.",
  "将当前填写的尺寸保存到站内尺码库（含款号与自动规则），下次可从下拉选用；同时会同步到平台尺码表库。": "Save current measurements to the site size library (style no. and auto-rule included) for reuse from the dropdown; also syncs to the platform size chart library.",
  "尺码表不符合平台填写要求": "Size chart does not meet platform requirements",
  "展开全部（{0}）": "Show all ({0})",
  "工作表": "Sheet",
  "已保存为产品模板": "Saved as product template",
  "已保存到官方尺码库": "Saved to official size library",
  "已保存到尺码库": "Saved to size library",
  "已保存到属性库": "Saved to attribute library",
  "已保存到站内尺码库（未提交平台）": "Saved to site size library (not submitted to platform)",
  "已保存本地尺码模板": "Local size template saved",
  "已创建平台尺码表": "Platform size chart created",
  "已导出完整 JSON {0} 条": "Exported {0} full JSON record(s)",
  "已更新平台尺码表": "Platform size chart updated",
  "已重新加载尺码库": "Size library reloaded",
  "平台写入不可用，已保存到本地": "Platform write unavailable; saved locally",
  "平台尺码表 ID：{0}（类目创建后不可改）": "Platform size chart ID: {0} (cannot change after category is set)",
  "平台尺码表写入不可用，已保存到本地尺码库": "Platform size chart write unavailable; saved to local size library",
  "开启后，发品选中该类目时自动带出。优先级仅在同类目内比较，数字越小越优先。": "When enabled, auto-applies when this category is selected in publish. Priority applies within the same category only; lower number wins.",
  "开启后，发品选中该类目时自动带出。优先级仅在同类目内比较，数字越小越优先；同类目不可重复，不同类目互不影响。": "When enabled, auto-applies when this category is selected in publish. Priority applies within the same category only (lower number wins); unique per category, independent across categories.",
  "开始导入": "Start import",
  "当前尺码表为空，无法保存": "Size chart is empty; cannot save",
  "成功导入 {0} 条": "Imported {0} item(s) successfully",
  "批量删除({0})": "Batch delete ({0})",
  "批量删除{0}": "Batch delete {0}",
  "文件{0}": "File {0}",
  "文件中没有可导入的模板": "No importable templates in file",
  "文件内容无效": "Invalid file content",
  "文件校验失败": "File validation failed",
  "文件类型不匹配（当前页为{0}，文件为{1}）": "File type mismatch (page: {0}, file: {1})",
  "新建官方尺码模板": "New official size template",
  "新建官方属性模板": "New official attribute template",
  "新建官方证书模板": "New official certificate template",
  "新建尺码库": "New size library",
  "新建属性库": "New attribute library",
  "无法读取当前商品内容": "Cannot read current product content",
  "暂无参考店铺，无法按类目规则校验尺码表，请先授权同类型 TikTok 店铺": "No reference shop to validate size chart by category rules. Authorize a TikTok shop of the same type first.",
  "暂无可用参考店铺，无法加载尺码填写规则。请先授权同类型 TikTok 店铺。": "No reference shop to load size fill rules. Authorize a TikTok shop of the same type first.",
  "暂无官方{0}": "No official {0} yet",
  "暂无尺寸选项": "No size options",
  "未命名模板": "Untitled template",
  "未找到匹配的{0}": "No matching {0}",
  "未知的模板类型": "Unknown template type",
  "未解析到字段级差异（模板元数据或结构可能已变）。重新加载仍会用最新模板覆盖该区域。": "No field-level diff detected (metadata or structure may have changed). Reloading still overwrites this area with the latest template.",
  "未选择文件": "No file selected",
  "松开上传": "Release to upload",
  "模板": "Template",
  "测量值请填完整，不可留空": "Fill all measurement values; none may be empty",
  "点击或拖拽上传": "Click or drag to upload",
  "确认": "Confirm",
  "确认保存": "Confirm save",
  "确认删除「{0}」？此操作不可恢复。": "Delete \"{0}\"? This cannot be undone.",
  "确认删除选中的 {0} 条模板？此操作不可恢复。": "Delete {0} selected template(s)? This cannot be undone.",
  "第 {0} 条": "Item {0}",
  "第 {0} 行缺少模板名称": "Row {0} is missing template name",
  "编辑官方尺码模板": "Edit official size template",
  "编辑官方属性模板": "Edit official attribute template",
  "编辑官方证书模板": "Edit official certificate template",
  "编辑尺码库": "Edit size library",
  "编辑属性库": "Edit attribute library",
  "英制 (IMPERIAL)": "Imperial (IMPERIAL)",
  "该类目不支持尺码表，将仅保存站内草稿": "This category does not support size charts; only a site draft will be saved",
  "该类目暂无商品属性，仅有销售属性 {0} / 尺寸属性 {1}": "No product attributes for this category; only sales attrs {0} / size attrs {1}",
  "该类目缺少商品类型，无法加载属性": "Category missing product type; cannot load attributes",
  "请上传 JSON、Excel 或 zip 文件": "Upload a JSON, Excel, or zip file",
  "请先完整填写尺寸信息": "Complete size information first",
  "请先选择尺寸": "Select a size first",
  "请填写尺码名称（Size）": "Enter size name (Size)",
  "请填写必填测量项「{0}」": "Fill required measurement \"{0}\"",
  "请完善均码测量值": "Complete one-size measurements",
  "请至少完整填写一列测量值": "Fill at least one complete measurement column",
  "请至少选择一列测量项": "Select at least one measurement column",
  "请选择单位制": "Select unit system",
  "请选择或自定义尺寸，回车添加（均码与其它尺码互斥）": "Select or type a size and press Enter (one size excludes other sizes)",
  "请选择测量类型": "Select measurement type",
  "请选择要将官方模板复制到的店铺（保存到个人模板）。": "Select the shop to copy the official template to (saved as personal template).",
  "返回修改": "Back to edit",
  "选中记录缺少 id，无法导出完整内容": "Selected row missing id; cannot export full content",
  "选填列「{0}」请整列填完或整列留空": "Optional column \"{0}\": fill the entire column or leave it empty",
  "选择复制到的店铺": "Select shop to copy to",
  "选择店铺": "Select shop",
  "选择新建到的店铺": "Select shop to create in",
  "选择证书类型": "Select certificate type",
  "选项": "Options",
  "（空）": "(Empty)",
  "单店铺独享": "Single-shop only",
  "团队店铺共享": "Team shops shared",
  "官方": "Official",
  "产品模板": "Product template",
  "尺码库": "Size library",
  "属性库": "Attribute library",
  "实拍图库": "Photo library",
  "素材模板": "Material template",
  "通用测量": "Generic measurements",
  "人体测量": "Body measurements",
  "成衣/产品测量": "Garment / product measurements",

  // --- merged TikTok i18n ---
  "审核中": "Under review",
  "最近同步：{0}": "Last sync: {0}",
  "已复制 {0} 个编号": "Copied {0} id(s)",
  "读取店铺信息缓存失败": "Failed to read shop info cache",
  "头像上传失败": "Avatar upload failed",
  "查看详情": "View details",
  "查看并同步": "View and sync",

  // --- merged TikTok i18n ---
  "待处理": "Pending",
  "已拒绝": "Rejected",
  "待买家寄回": "Awaiting buyer return",
  "买家已寄出": "Buyer shipped",
  "拒绝收货": "Reject package",
  "退货成功": "Return succeeded",
  "已取消": "Cancelled",
  "待付款": "Unpaid",
  "保留中": "On hold",
  "待发货": "Awaiting shipment",
  "部分发货": "Partially shipped",
  "待揽收": "Awaiting collection",
  "运输中": "In transit",
  "已送达": "Delivered",
  "已发货": "Shipped",
  "已签收": "Signed",
  "已退款": "Refunded",
  "已报损": "Written off",
  "已拒收": "Rejected receipt",
  "TikTok自营库存": "TikTok self-operated inventory",
  "备货到TikTok仓(SFS)": "Stock to TikTok warehouse (SFS)",
  "商家仓发货": "Merchant warehouse shipping",
  "待调价": "Pending price adjust",
  "待卖家确认": "Awaiting seller confirm",
  "调价成功": "Price adjust succeeded",
  "调价失败": "Price adjust failed",
  "不需要填材料": "No materials required",
  "类型一材料必填（文件必填，链接选填）；类型二选填": "Type-1 materials required (file required, link optional); type-2 optional",
  "类型一或类型二至少填一种": "Fill at least type-1 or type-2",
  "部分通过": "Partially approved",
  "已撤回": "Withdrawn",

  // --- merged TikTok i18n ---
  "原价": "Original price",
  "{0}折": "{0}/10 price",
  "已复制 {0} 个 ID": "Copied {0} ID(s)",

  // --- merged TikTok i18n ---
  "对接 TikTok 本土店后，本地发品与订单更顺一截": "After connecting a TikTok local shop, local listing and orders flow more smoothly in one workspace",
  "把产品发布、合规资料、订单售后与经营数据收进同一工作区——本土发品不绑站点·仓·运费，平台按本土物流计费。": "Bring product publishing, compliance, orders, after-sales, and analytics into one workspace—local listings skip site/warehouse/shipping templates; platform bills local logistics.",
  "发品链路齐全": "End-to-end listing",
  "发布产品、产品信息、发布记录与草稿箱同壳管理，状态可追踪。": "Publish products, product info, publish history, and drafts in one shell with traceable status.",
  "模板与合规就位": "Templates and compliance ready",
  "产品模板、尺码库、属性库、品牌库与合规资料可复用；本土不展示发货仓库与运费模板。": "Reuse product templates, size charts, attributes, brands, and compliance; local shops hide warehouse and shipping templates.",
  "订单与经营可同步": "Orders and ops data sync",
  "订单列表、退货退款、取消单、营销活动、经营数据与财务账单按授权店铺拉取。": "Pull orders, returns/refunds, cancellations, campaigns, analytics, and finance per authorized shop.",
  "店铺类型强隔离": "Strict shop-type isolation",
  "工作区 Session 绑定「本土」；与跨境、以及 SHEIN / TEMU 工作区互不串台，跨类型需回门禁重验。": "Workspace session binds to Local; isolated from Cross-border and SHEIN/TEMU; switching types requires re-auth at the gate.",
  "对接 TikTok 全托管后，供货与经营收进同一工作区": "After TikTok full-service hosting, supply and ops live in one workspace",
  "全托管走 Global Selling 独立应用。发品不绑站点、仓和运费，订单、经营数据与财务按该类型店铺隔离。": "Full-service uses a separate Global Selling app. Listings skip site/warehouse/shipping; orders, analytics, and finance are isolated per shop type.",
  "独立应用授权": "Dedicated app authorization",
  "全托管使用单独的 App Key / Service ID，不能和跨境、本土应用混用。": "Full-service uses its own App Key/Service ID—do not mix with cross-border or local apps.",
  "发品按全托口径": "Listing for full-service rules",
  "跳过发货仓库与运费模板，套用发品时也不提交这些字段。": "Skip warehouse and shipping templates; applying listings does not submit those fields.",
  "经营数据可同步": "Ops data sync",
  "订单、营销、经营数据与财务账单按当前全托管店铺拉取。": "Pull orders, marketing, analytics, and finance for the current full-service shop.",
  "工作区 Session 绑定「全托管」；与跨境、本土以及 SHEIN / TEMU 工作区互不串台。": "Session binds to Full-service; isolated from cross-border, local, and SHEIN/TEMU workspaces.",
  "对接 TikTok 跨境店后，发品与运营更顺一截": "After connecting a TikTok cross-border shop, listing and ops get smoother",
  "把产品发布、模板库、合规、订单与财务收进同一工作区——跨境发品可选用发货仓库与运费模板，少切换工具。": "Unify publishing, templates, compliance, orders, and finance—cross-border listings can use warehouse and shipping templates with fewer tool switches.",
  "设计到上架不断层": "Design to shelf without gaps",
  "IPE 产出可衔接 TikTok 发品：发布产品、产品信息、发布记录与草稿箱同一工作流。": "IPE output flows into TikTok listing: publish, product info, history, and drafts in one workflow.",
  "模板与仓运费齐备": "Templates, warehouse, and shipping",
  "产品模板、尺码/属性/品牌库，以及发货仓库、运费模板，服务跨境 Create Product 必填项。": "Product templates, size/attribute/brand libraries, plus warehouse and shipping templates for cross-border Create Product required fields.",
  "运营模块可同步": "Ops modules sync",
  "合规资料、营销活动、订单/售后、经营数据与财务账单按当前授权店铺本地缓存与同步。": "Compliance, campaigns, orders/after-sales, analytics, and finance cache and sync per authorized shop.",
  "工作区 Session 绑定「跨境」；不可操作本土能力，亦与 SHEIN / TEMU 工作区完全分离。": "Session binds to Cross-border; no local-only features; fully separate from SHEIN/TEMU.",
  "TikTok美国站": "TikTok US shop",
  "TikTok英国站": "TikTok UK shop",
  "TikTok法国站": "TikTok France shop",
  "TikTok德国站": "TikTok Germany shop",
  "TikTok西班牙站": "TikTok Spain shop",
  "TikTok意大利站": "TikTok Italy shop",
  "TikTok荷兰站": "TikTok Netherlands shop",
  "TikTok波兰站": "TikTok Poland shop",
  "TikTok瑞典站": "TikTok Sweden shop",
  "TikTok葡萄牙站": "TikTok Portugal shop",
  "TikTok欧洲站": "TikTok Europe shop",
  "TikTok墨西哥站": "TikTok Mexico shop",
  "TikTok巴西站": "TikTok Brazil shop",
  "TikTok澳大利亚站": "TikTok Australia shop",
  "TikTok加拿大站": "TikTok Canada shop",
  "TikTok日本站": "TikTok Japan shop",
  "TikTok印尼站": "TikTok Indonesia shop",
  "TikTok马来西亚站": "TikTok Malaysia shop",
  "TikTok泰国站": "TikTok Thailand shop",
  "TikTok越南站": "TikTok Vietnam shop",
  "TikTok菲律宾站": "TikTok Philippines shop",
  "TikTok新加坡站": "TikTok Singapore shop",
  "减 {0}%（打{1}折）": "{0}% off ({1}×10 discount)",
  "减 {0}%": "{0}% off",
  "运费全免": "Free shipping",
  "运费{0}": "Shipping {0}",
  "减 {0}": "−{0}",
  "立减 {0}": "Instant −{0}",
  "赠品{0}": "Gift {0}",
  "买赠，商品价不变": "Buy-X-get-Y; product price unchanged",
  "折扣已固定": "Discount fixed at creation",
  "营销活动": "Marketing campaign",
  "加载店铺商品失败": "Failed to load shop products",
  "请填写 1 到 99 的折扣百分比": "Enter a discount percentage from 1 to 99",
  "请填写活动价": "Enter campaign price",
  "商品 {0} 缺少 SKU，无法按规格提报": "Product {0} has no SKU; cannot enroll by variation",
  " · 活动 ID {0}": " · Campaign ID {0}",
  " · 按 SKU 报价": " · Quote per SKU",
  " · 按商品报价": " · Quote per product",
  " · 正在读取报价维度": " · Loading quote dimension…",
  " · 折扣在创建活动时已固定，报名不再填写活动价": " · Discount was fixed when the campaign was created; no price entry at enrollment",
  " · 折扣写在每个 SKU 上，10 表示打九折": " · Discount per SKU; 10 means 10% off (90% of price)",
  " · 活动价写在每个 SKU 上": " · Campaign price per SKU",
  " · 折扣写在商品上，10 表示打九折": " · Discount on product; 10 means 10% off",
  " · 活动价写在商品上，SKU 列表必须为空": " · Campaign price on product; SKU list must be empty",
  "返回活动列表": "Back to campaign list",
  "提交报名（已选 {0}）": "Submit enrollment ({0} selected)",
  "填入已选": "Apply to selected",
  "不填（平台默认）": "Leave blank (platform default)",
  "一次性包装（SINGLE_USE）": "Single-use packaging (SINGLE_USE)",
  "可回收包装（REUSABLE）": "Reusable packaging (REUSABLE)",
  "不适用（NOT_APPLICABLE）": "Not applicable (NOT_APPLICABLE)",
  "制造商已创建": "Manufacturer created",
  "欧盟负责人已创建": "EU responsible person created",
  "制造商列表加载失败": "Failed to load manufacturers",
  "负责人列表加载失败": "Failed to load responsible persons",
  "认证文件上传失败": "Certification file upload failed",
  "当前按「{0}」搜索": "Searching for “{0}”",
  "押金按 SKU 提交（`skus[].fees`），当前金额会应用到全部 SKU。取值范围 0.00–6300.00。": "Deposit is submitted per SKU (`skus[].fees`); the amount applies to all SKUs. Range 0.00–6300.00.",
  "官方模板选填。可搜索已同步的制造商，或点击新建；复制到欧盟/英国店铺时保留，其它市场会去掉。": "Optional on official templates. Search synced manufacturers or create new; kept when copying to EU/UK shops, stripped for other markets.",
  "欧盟/英国市场选填。可搜索已同步的制造商，或点击新建；组合商品各子品信息不同时请分别维护。": "Optional for EU/UK. Search synced manufacturers or create new; maintain separately for bundle components when details differ.",
  "暂无制造商，请先新建": "No manufacturers—create one first",
  "官方模板选填（Responsible Person）。可搜索已同步的责任人，或点击新建；复制到欧盟/英国店铺时保留，其它市场会去掉。": "Optional on official templates (Responsible Person). Search synced persons or create new; kept for EU/UK copies, stripped elsewhere.",
  "欧盟/英国市场选填（Responsible Person）。可搜索已同步的责任人，或点击新建。": "Optional for EU/UK (Responsible Person). Search synced persons or create new.",
  "暂无责任人，请先新建": "No responsible persons—create one first",
  "本类目要求 EPR 信息。Create Product 无独立 EPR 字段，请在上方「商品合规」中填写平台下发的相关项（如 EPR 注册号）。": "This category requires EPR info. Create Product has no separate EPR field—fill platform EPR items (e.g. registration number) under Product compliance above.",
  "尺码表#{0}": "Size chart #{0}",
  "{0} · {1}": "{0} · {1}",

  // --- merged TikTok i18n ---
  "请填写重量": "Enter weight",
  "重量无效": "Invalid weight",
  "请选择 SKU 分类": "Select SKU classification",
  "请填写单品数量": "Enter piece quantity",
  "单品数量无效": "Invalid piece quantity",
  "单品数量须为整数": "Piece quantity must be an integer",
  "共计内含无效": "Invalid total contents",
  "共计内含须为整数": "Total contents must be an integer",
  "敏感属性为「是」时请至少选择 1 个类型": "When sensitive is Yes, select at least one type",
  "请至少填写 1 项包装清单（物品 + 数量）": "Enter at least one packing-list item (product + qty)",
  "应用范围": "Apply scope",
  "全部 SKU": "All SKUs",
  "按尺码": "By size",
  "如 200": "e.g. 200",
  "选填": "Optional",
  "件": "pc",

  // --- remaining TikTok UI ---
  "· 主销售属性": " · Main sales attribute",
  "· 全托/本土": " · Full-service / local",
  "· 其他站点可汇总填写": " · Other sites: enter once in aggregate",
  "· 半托管": " · Semi-managed",
  "· 叶子": " · Leaf",
  "· 套装类型需至少 2 张尺码表": " · Set type requires at least 2 size charts",
  "· 已翻译": " · Translated",
  "· 折扣写在商品上，10 表示打九折": " · Discount on product; 10 means 90% of list price",
  "· 折扣写在每个 SKU 上，10 表示打九折": " · Discount per SKU; 10 means 90% of list price",
  "· 折扣在创建活动时已固定，报名不再填写活动价": " · Discount fixed at campaign creation; no price entry at enrollment",
  "· 按 SKU 报价": " · Quote per SKU",
  "· 按商品报价": " · Quote per product",
  "· 未选品牌（规则接口可不传品牌）": " · No brand selected (brand optional in rules API)",
  "· 正在读取报价维度": " · Loading quote dimension…",
  "· 活动 ID {0}": " · Campaign ID {0}",
  "· 活动价写在商品上，SKU 列表必须为空": " · Campaign price on product; SKU list must be empty",
  "· 活动价写在每个 SKU 上": " · Campaign price per SKU",
  "· 联动": " · Linked",
  "· 需按站点维度填写": " · Fill per site",
  "「从说明书制作工具选择」为卖家中心站内工具，本系统暂不内嵌，请在卖家中心制作后导出 PDF 再本地上传。": "Choose from manual builder is a Seller Center tool and is not embedded here. Create the manual in Seller Center, export PDF, then upload locally.",
  "「翻译多语言并上传」会先上传源文件，再调用平台翻译接口生成多语种 PDF。": "Translate & upload uploads the source file first, then calls the platform translation API to generate multilingual PDFs.",
  "「说明书制作工具」为 Tiktok 卖家中心站内能力，本工作台暂不内嵌。请在卖家中心制作并导出 PDF 后，切换到「从本地上传」。": "The manual builder is a TikTok Seller Center feature and is not embedded in this workspace. Create and export a PDF in Seller Center, then switch to Upload from device.",
  "上传主图视频（≤20MB，建议 1:1 / 3:4）": "Upload main video (≤20MB; 1:1 or 3:4 recommended)",
  "上传未返回 pdfId": "Upload did not return pdfId",
  "上传未返回 url": "Upload did not return url",
  "上传类型一材料": "Upload type-1 materials",
  "上传类型二材料": "Upload type-2 materials",
  "下一步": "Next",
  "下架": "Delist",
  "不合格": "Fail",
  "不符合": "Non-compliant",
  "不限制站点": "All sites",
  "中断": "Interrupted",
  "主图/细节图按平台要求裁为 3:4，边长 300～4000px（推荐 1200×1600，≤10MB）。比例或尺寸不合规时请拖动裁剪框选择要保留的区域。": "Crop main/detail images to 3:4, 300–4000px side (1200×1600 recommended, ≤10MB). If ratio or size is invalid, drag the crop box to choose the area to keep.",
  "仅支持 PDF 格式，单个文件 ≤50MB。": "PDF only; each file ≤50MB.",
  "仅支持 PDF，且每个文件在 50MB 以内。": "PDF only; each file must be under 50MB.",
  "从 TikTok 后台拉取促销活动到本地缓存；进页读取本地数据，点击同步更新。": "Pull TikTok campaigns into local cache. This page reads local data; click Sync to refresh.",
  "从 TikTok 后台查询当前筛选条件下的优惠券。优惠券只能在卖家中心创建。": "Query coupons for the current filters from TikTok. Coupons can only be created in Seller Center.",
  "从本地上传": "Upload from device",
  "从说明书制作工具选择": "Choose from manual builder",
  "代理": "Agent",
  "优惠券分页": "Coupons pagination",
  "优惠码": "Promo code",
  "入库": "Inbound",
  "全托管": "Full-service",
  "全选活动": "Select all campaigns",
  "全部展示": "Show all",
  "全部状态": "All statuses",
  "其他站点": "Other sites",
  "加载价格列表失败": "Failed to load price list",
  "反馈": "Feedback",
  "发品尺码表": "Listing size chart",
  "发品流程以 PDF 说明书文件为准（写入 productGuideFileReqs）。安装/使用说明与安全信息的结构化文本编辑目前请在 Tiktok 卖家中心完成；此处仍可通过下方上传更新说明书文件。": "Listing uses PDF manual files (productGuideFileReqs). Edit structured install/usage and safety text in TikTok Seller Center for now; you can still update the PDF below.",
  "发布中…": "Publishing…",
  "合格": "Pass",
  "同步完成，刷新列表…": "Sync complete; refreshing list…",
  "同步时一并拉取活动商品到本地缓存；进页读取本地数据。": "Sync also pulls campaign products into local cache. This page reads local data.",
  "售后": "After-sales",
  "图片上传失败": "Image upload failed",
  "图片上传未返回 TikTok 地址，请重试": "Image upload did not return a TikTok URL. Retry.",
  "图片上传未返回地址，请重试": "Image upload did not return a URL. Retry.",
  "图片上传未返回平台 uri，请重试（勿用未转图的外链）": "Image upload did not return platform uri. Retry (do not use untransferred external links).",
  "图片已上传": "Image uploaded",
  "图片已选用": "Image selected",
  "图片选用失败": "Failed to select image",
  "大促活动": "Major promotion",
  "套用尺码库失败": "Failed to apply size library",
  "实拍": "Real photo",
  "客服": "Customer service",
  "客服会话": "CS chat",
  "对账": "Reconciliation",
  "尚未同步促销活动": "Campaigns not synced yet",
  "尚未同步核价单": "Price reviews not synced yet",
  "尚未同步活动商品": "Campaign products not synced yet",
  "尚未同步调价单": "Price adjustments not synced yet",
  "尺码库为空，已清空产品尺寸": "Size library is empty; product dimensions cleared",
  "已上传说明书（语种识别中，已默认 en，提交前请刷新核对）": "Manual uploaded (language detecting; default en—refresh and verify before submit)",
  "已下架": "Delisted",
  "已取消裁剪，未上传该图片": "Crop cancelled; image not uploaded",
  "已取消裁剪，未选用该图片": "Crop cancelled; image not selected",
  "已售罄": "Sold out",
  "常规": "Regular",
  "平台": "Platform",
  "平台要求说明书必须包含英文内容；语种由平台自动识别。": "Platform requires English in the manual; language is auto-detected.",
  "建议": "Suggested",
  "当前筛选条件下没有核价待办。": "No price-review tasks for the current filters.",
  "当前筛选条件下没有调价待办。": "No price-adjustment tasks for the current filters.",
  "当前类目暂无尺寸属性（attribute_type=2），无需填写尺码表": "This category has no size attributes (attribute_type=2); no size chart needed",
  "当前类目要求必传说明书。": "This category requires a manual.",
  "当前规则下无需填写建议零售价": "Suggested retail price not required under current rules",
  "待上架": "Pending listing",
  "待办": "To-do",
  "必填": "Required",
  "所有尺码共用此值": "All sizes share this value",
  "报名时检测": "Checked at enrollment",
  "报告": "Report",
  "报错": "Error",
  "拖拽调整顺序": "Drag to reorder",
  "按类目要求上传多语言 PDF 说明书。平台会识别语种；发品提交写入 productGuideFileReqs。必须包含英文内容。": "Upload multilingual PDF manuals per category rules. Platform detects language; submit writes productGuideFileReqs. English required.",
  "按需上传；覆盖更多语言有助于转化与降低客诉（平台未提供类目必填查询，发布时以平台校验为准）。": "Upload as needed; more languages help conversion and reduce complaints (no category required API—platform validation at publish applies).",
  "授权": "Authorization",
  "提交发布": "Submit publish",
  "无匹配核价单": "No matching price reviews",
  "无匹配调价单": "No matching price adjustments",
  "暂无促销活动": "No campaigns yet",
  "暂无活动商品，请先同步或到活动详情查看": "No campaign products. Sync first or open campaign details.",
  "更新活动失败": "Failed to update campaign",
  "未授权": "Unauthorized",
  "未能获取填写规则，无法判断是否需要填写建议零售价。": "Could not load fill rules; cannot tell if suggested retail price is required.",
  "本土": "Local",
  "本地": "Local",
  "查看说明书上传要求": "View manual upload requirements",
  "标「共用」的列为平台单选：合并填写一次": "Columns marked Shared are platform single-select: fill once for all",
  "标签": "Tags",
  "正在查询活动…": "Loading campaigns…",
  "活动列表分页": "Campaign list pagination",
  "活动商品分页": "Campaign products pagination",
  "活动报名商品": "Campaign enrollment products",
  "活动标题（精确关键词）": "Campaign title (exact keyword)",
  "清仓甩卖": "Clearance",
  "点击「拉取 TikTok 后台数据」获取核价待办。": "Click Pull TikTok Seller Center data to load price-review tasks.",
  "点击「拉取 TikTok 后台数据」获取调价待办。": "Click Pull TikTok Seller Center data to load price-adjustment tasks.",
  "电子说明书": "Electronic manual",
  "移除图片": "Remove image",
  "符合": "Compliant",
  "类型一证明链接（可选）": "Type-1 proof link (optional)",
  "类型二证明链接（可选）": "Type-2 proof link (optional)",
  "素材/SKU 变体图须为 1:1，边长≥300px（推荐 800×800，平台允许 300～4000，≤10MB）。比例或尺寸不合规时请拖动裁剪框选择要保留的区域。": "Material/SKU variant images must be 1:1, side ≥300px (800×800 recommended; 300–4000 allowed, ≤10MB). Drag the crop box if ratio or size is invalid.",
  "绑定": "Bind",
  "绑定公司": "Bind company",
  "翻译上传中…": "Translating upload…",
  "翻译多语言上传失败": "Multilingual translation upload failed",
  "翻译未返回 translateId": "Translation did not return translateId",
  "自动过滤": "Auto filter",
  "补全": "Complete",
  "补证": "Supplement proof",
  "裁剪为 1:1 素材图": "Crop to 1:1 material image",
  "裁剪为 3:4 商品图": "Crop to 3:4 product image",
  "规格": "Spec",
  "视频处理中…": "Processing video…",
  "角标": "Badge",
  "证书缺失": "Certificate missing",
  "证明材料已上传": "Proof materials uploaded",
  "语种待识别": "Language pending detection",
  "说明书上传失败": "Manual upload failed",
  "说明书应尽可能覆盖更多语言，有助于提升转化并降低客诉。": "Cover more languages in the manual to improve conversion and reduce complaints.",
  "说明书翻译超时，请稍后在列表中核对或重新上传": "Manual translation timed out. Check the list later or re-upload.",
  "请先填写产品尺寸再保存到尺码库": "Fill product dimensions before saving to size library",
  "请先选择商品类目": "Select a product category first",
  "请先选择店铺后再上传图片": "Select a shop before uploading images",
  "请在右上角选择已授权的 TikTok 店铺。": "Select an authorized TikTok shop in the top-right.",
  "调价单": "Price adjustments",
  "财务": "Finance",
  "账单": "Billing",
  "资质": "Qualifications",
  "超级万人团": "Super group deal",
  "超级秒杀": "Super flash sale",
  "达人专属": "Creator exclusive",
  "过期": "Expired",
  "进度": "Progress",
  "退款": "Refund",
  "退货": "Return",
  "选择图片上传到 Tiktok": "Select images to upload to TikTok",
  "重新发布失败": "Republish failed",
  "重新查询": "Search again",
  "限时秒杀": "Flash sale",
  "非必填": "Optional",
  "首页": "Home",
  "（服饰按颜色拆 SKC）": "(Apparel: split SKC by color)",
  "（未选品牌 / 无品牌）": "(No brand selected / no brand)",
  "（本页暂不支持）": "(Not supported on this page)",
  "（非服饰单 SKC）": "(Non-apparel: single SKC)",
  "：分站点与不分站点均为不允许。": ": Per-site and non–per-site are both disallowed.",
  "核价": "Price review",
  "调价": "Price adjust",
  "选择场次": "Select sessions",
  "选择站点": "Select sites",
  "活动场次列表": "Campaign sessions",
  "经营站点列表": "Selling sites",
  "请返回上一步重新选择场次。": "Go back and reselect sessions.",
  "当前商品未返回站点信息。": "This product has no site info.",
  "场次分页": "Session pagination",
  "站点分页": "Site pagination",
  "已选场次 {0}": "Selected sessions: {0}",
  "已选站点 {0}": "Selected sites: {0}",
  "是否可发品": "Can publish",
  "暂无法确认": "Not confirmed yet",
  "不可发品": "Cannot publish",
  "可发品": "Can publish",
  "不可发品原因": "Block reason",
  "这是 TikTok 平台侧返回的异常，可稍后再次同步；或登录商家后台核对店铺处置/违规状态。": "TikTok returned an error. Sync again later, or check shop penalties / violations in Seller Center.",
  "请前往 TikTok 商家后台处理相关问题后再尝试发品。": "Resolve the issue in TikTok Seller Center before publishing.",
  "接收时间": "Received at",
  "重放中…": "Replaying…",
  "重放": "Replay",
  "上一页": "Previous",
  "下一页": "Next",
  "查看 TikTok 平台推送事件，支持失败事件手动重放触发增量同步。": "View TikTok push events. Replay failed events to trigger incremental sync.",
  "第 {0} 页 · 共 {1} 条": "Page {0} · {1} total",
  "加载 Webhook 事件失败": "Failed to load webhook events",
  "重放成功": "Replay succeeded",
  "重放完成：{0}": "Replay finished: {0}",
  "请查看处理备注": "Check the processing note",
  "重放失败": "Replay failed",
  "暂无 Webhook 事件": "No webhook events",
  "加载详情失败": "Failed to load details",
  "删": "Del",
  "图片走 image.upload.global；视频走 sign → galerie 上传 → 转码结果（≤20MB）。发品使用返回 URL/vid。": "Images use image.upload.global; videos use sign → Galerie upload → transcode (≤20MB). Publish with returned URL/vid.",
  "当前规格组合将生成 {0} 个 SKU{1}。": "This spec combo will create {0} SKU(s){1}.",
  "服饰类目（颜色作主销售属性拆 SKC）": "Apparel (split SKC by color as main sales attribute)",
  "将调用 {0}。": "Will call {0}.",
  "尺码 ID：{0}；": "Size IDs: {0};",
  "视频 {0} 个。": "{0} video(s).",
  "将调用 {0}。尺码 ID：{1}；视频 {2} 个。": "Will call {0}. Size IDs: {1}; {2} video(s).",
  "请填写名称": "Enter a name",
  "请填写邮箱": "Enter an email",
  "请填写国家码": "Enter a country code",
  "请填写本地号码": "Enter a local number",
  "请填写地址": "Enter an address",
  "平台未返回文件 id": "Platform did not return a file id",
  "产品ID: {0}": "Product ID: {0}",
  "选择站点 {0}": "Select site {0}",
  "同类型已授权店铺不足 2 家，无法进入全部视图": "Need at least 2 authorized shops of this type to use the All shops view",
  "店铺不存在": "Shop not found",
  "只能切换已授权的店铺": "You can only switch to authorized shops",
  "只能切换同类型店铺（当前「{0}」，目标「{1}」）。跨类型请返回门禁重进。": "You can only switch shops of the same type (current “{0}”, target “{1}”). To change type, go back through the gate.",
  "选择场次 {0}": "Select session {0}",
  "未知": "Unknown",
  "（工作日）": " (business days)",
  "（日历日）": " (calendar days)",
  "预售发货时长须为 {0}–{1} 天{2}": "Pre-sale handling time must be {0}–{1} days{2}",
  "「{0}」{1}": "“{0}”{1}",
  "鞋模": "Shoe model",
  "模特#{0}": "Model #{0}",
  "模特列表加载失败": "Failed to load models",
  "无匹配模特": "No matching models",
  "暂无可用模特": "No models available",
  "暂无平台模特。请先到「模板库 · 模特库」新建，或点击「拉取 TikTok 后台数据」。": "No platform models yet. Create one in Template Library · Models, or click Pull TikTok Seller Center data.",
  "试穿 {0}": "Try-on {0}",
  "感受 {0}": "Fit {0}",
  "部分同步失败（{0}）：{1}": "Partial sync failed ({0}): {1}",
  "身高": "Height",
  "胸围": "Bust",
  "腰围": "Waist",
  "臀围": "Hips",
  "脚长": "Foot length",
  "脚宽": "Foot width",
  "卖家权限": "Seller permissions",
  "、": ", ",
  "批量填写活动申报价": "Batch fill campaign declare price",
  "批量填写活动库存": "Batch fill campaign stock",
  "如 97": "e.g. 97",
  "如 199": "e.g. 199",
  "将应用到当前勾选商品；未勾选时应用到当前列表全部商品。": "Applies to selected products; if none selected, applies to the whole list.",
  "将统一写入当前勾选商品的活动库存；未勾选时应用到当前列表全部商品。": "Writes campaign stock for selected products; if none selected, applies to the whole list.",
  "邀约报名": "Invite-only enrollment",
  "专题 {0}": "Theme {0}",
  "状态 {0}": "Status {0}",
  "加载活动详情失败": "Failed to load campaign details",
  "加载活动商品失败": "Failed to load campaign products",
  "暂无核价单": "No pricing sheets",
  "紧身": "Tight",
  "宽松": "Loose",
  "已下线": "Offline",
  "报名中": "Enrolling",
  "待分配": "Pending assignment",
  "已分配": "Assigned",
  "报名成功": "Enrollment successful",
  "从 TikTok 开放平台拉取并更新本地：\n· Get Authorized Shops → 基本信息（店铺名 / Seller Id / 类型 / 授权）\n· Get Active Shops → 售卖站点（经营 region）\n· Get Seller Permissions → 权限快照\n· Get Categories → 可发类目（is_leaf + AVAILABLE）\n品牌请到「模板库 · 品牌库」单独同步。": "Pull from the TikTok Open Platform and update local data:\n· Get Authorized Shops → basic info (shop name / Shop ID / Cipher / type / auth)\n· Get Active Shops → selling sites (operating region)\n· Get Seller Permissions → permission snapshot\n· Get Categories → publishable categories (is_leaf + AVAILABLE)\nSync brands separately in Template Library · Brands.",
  "从 TikTok 开放平台拉取并更新本地：\n· Get Authorized Shops → 基本信息（店铺名 / 店铺 ID / Cipher / 类型 / 授权）\n· Get Active Shops → 售卖站点（经营 region）\n· Get Seller Permissions → 权限快照\n· Get Categories → 可发类目（is_leaf + AVAILABLE）\n品牌请到「模板库 · 品牌库」单独同步。": "Pull from the TikTok Open Platform and update local data:\n· Get Authorized Shops → basic info (shop name / Shop ID / Cipher / type / auth)\n· Get Active Shops → selling sites (operating region)\n· Get Seller Permissions → permission snapshot\n· Get Categories → publishable categories (is_leaf + AVAILABLE)\nSync brands separately in Template Library · Brands.",
  "请选择或搜索": "Select or search",
  "无匹配选项": "No matching options",
  "搜索中…": "Searching…",
  "核价单 · 平台 JSON": "Price review · platform JSON",
  "调价单 · 平台 JSON": "Price adjust · platform JSON",
  "当前行平台 item": "Current row platform item",
  "最近同步 dump": "Latest sync dump",
  "读取同步 dump 失败（请先点拉取 TikTok 后台数据）": "Failed to read sync dump (pull TikTok Seller Center data first)",
  "当前行无平台原始 JSON（请先同步入库）": "No platform JSON on this row (sync first)",
  "读取同步 dump 失败（请先点「同步店铺信息」）": "Failed to read sync dump (click Sync shop info first)",
  "最近一次同步店铺信息时平台返回的原始响应（含 success / errorCode / result，未改写）": "Raw response from the last shop-info sync (success / errorCode / result, unmodified)",
  "共 {0} 个尺码": "{0} sizes",
  "重新加载模板区域": "Reload template section",
  "以下字段与模板库最新版本不一致，重新加载将覆盖对应区域（其它区域保留）：": "These fields differ from the latest template library version. Reloading overwrites this section (other sections stay):",
  "每行一条，或用逗号分隔；最多 500 条": "One per line or comma-separated; max 500",
  "已按上限保留前 {0} 条": "Kept the first {0} items by the limit",
  "支持换行或逗号分隔，单次最多查询 {0} 条": "Newline or comma separated; up to {0} per query",
  "已输入 {0} / {1}": "Entered {0} / {1}",
  "（超出将截断）": " (extras will be truncated)",
  "SKC ID 须为纯数字，已忽略无效项：{0}": "SKC IDs must be numeric; ignored invalid: {0}",
  "最多指定 {0} 个 SKC": "At most {0} SKCs",
  "同步分页数最多 {0}": "Sync pages max {0}",
  "当前行平台 JSON": "Current row platform JSON",
  "暂无平台 JSON": "No platform JSON",
  "当前行无平台 JSON（请先同步商品）": "No platform JSON on this row (sync products first)",
  "未解析到字段级差异。重新加载仍会用最新模板覆盖该区域。": "No field-level diff found. Reloading still overwrites this section with the latest template.",
  "…其余 {0} 项": "…and {0} more",
  "知道了": "Got it",
  "该同步今日已达上限（{0}次），请明天再试": "This sync hit today’s limit ({0}). Try again tomorrow.",
  "填写规则：": "Fill rules: ",
  "正在同步{0}…": "Syncing {0}…",
  "当前店铺模式无成本议价单 OpenAPI；请在 TikTok 卖家后台处理核价。": "This shop mode has no cost-discuss OpenAPI; handle price review in TikTok Seller Center.",
  "左侧为待核价商品；下方可加载状态为「待商家确认」的议价单并同意平台建议价。": "Left: products pending review. Below: load discuss sheets awaiting seller confirm and accept the suggested price.",
  "选择待确认议价单后可一键同意平台建议价；复议请跳转议价单重新报价。": "Select a pending discuss sheet to accept the suggested price; for reconsideration, open discuss and re-quote.",
  "加载待确认议价单失败": "Failed to load pending discuss sheets",
  "请在左侧列表使用同步/刷新核价状态": "Use sync / refresh price-review status in the left list",
  "已同意平台建议价（{0}）": "Accepted suggested price ({0})",
  "同意建议价失败": "Failed to accept suggested price",
  "刷新核价状态": "Refresh price-review status",
  "申请核价复议": "Request price-review reconsideration",
  "已填写说明": "Note filled",
  "「{0}」当前功能正在开发中": "“{0}” is under development",
  "已复制{0}": "Copied {0}",
  "复制{0}": "Copy {0}",
  "半托 bg.semi.price.review.page.query.order / 全托 bg.price.review.page.query": "Semi-managed bg.semi.price.review.page.query.order / Full-service bg.price.review.page.query",
  "半托 bg.semi.adjust.price.page.query.order / 全托 bg.full.adjust.price.page.query": "Semi-managed bg.semi.adjust.price.page.query.order / Full-service bg.full.adjust.price.page.query",
  "须为正整数": "Must be a positive integer",
  "小数最多 {0} 位": "At most {0} decimal places",
  "须为有效数字": "Must be a valid number",
  "整数部分不能有前导零": "Integer part cannot have leading zeros",
  "不能有前导零（如 02、00）": "No leading zeros (e.g. 02, 00)",
  "须为自然数": "Must be a natural number",
  "须为大于 0 的数字": "Must be a number greater than 0",
  "数字位数不符合平台规则": "Digit length does not meet platform rules",
  "须为有效数字，不能只填连接符": "Must be a valid number; connectors alone are not allowed",
  "区间仅支持两个数值": "Ranges support exactly two numbers",
  "当前属性不支持区间填写": "This attribute does not support range input",
  "数值范围须在[{0}~{1}]": "Value must be within [{0}~{1}]",
  "尺寸属性「{0}」为平台单选，API 在多尺码下无法填写；请只保留一个尺码规格，或更换类目": "Size attribute “{0}” is single-select; with multiple sizes the API cannot fill it. Keep one size spec or change category",
  "请先选择{0}后再填写必填尺码表": "Select {0} before filling required size chart",
  "尺寸表填写数值不能为空：{0}（单选，全商品仅填一次）": "Size chart value required: {0} (single-select, once per product)",
  "尺寸表填写数值不能为空：{0}{1}": "Size chart value required: {0}{1}",
  "{0}：{1}": "{0}: {1}",
  "{0}{1}：{2}": "{0}{1}: {2}",
  "（{0}）": "({0})",
  "请填写尺寸表必填项": "Fill required size chart fields",
  "请至少填写一项尺寸数值": "Enter at least one size measurement",
  "尺码表无法关联规格值，请重新勾选尺寸规格后再填写": "Size chart cannot link to specs; reselect size specs and refill",
  "尺寸表「{0}」未完整关联到每个规格": "Size chart “{0}” is not linked to every spec",
  "正在同步审核状态 {0}/{1}": "Syncing audit status {0}/{1}",
  "暂无可同步的发布记录（需有平台商品 ID）": "No publish records to sync (platform product ID required)",
  "Get Product 无数据 productId={0}": "Get Product returned no data for productId={0}",
  "Get Product 失败": "Get Product failed",
  "已终止同步": "Sync cancelled",
  "已同步审核状态：更新 {0} 条{1}": "Audit status synced: updated {0} records{1}",
  "，失败 {0} 条": ", {0} failed",
  "同步完成，但未能更新任何记录": "Sync finished but no records were updated",
  "缺少店铺 ID": "Shop ID is missing",
  "正在同步发布记录审核状态…": "Syncing publish-record audit status…",
  "同步任务不存在或已过期": "Sync job not found or expired",
  "刚刚": "Just now",
  "{0} 分钟前": "{0} min ago",
  "{0} 小时前": "{0} h ago",
  "缺少产品ID，无法校验是否可编辑": "Missing product ID; cannot check edit permission",
  "当前商品不可编辑（可能正在审核中）": "This product cannot be edited (may be under review)",
  "校验是否可编辑失败": "Failed to check edit permission",
  "平台尺码表写入不可用": "Platform size-chart write is unavailable",
  "图片上传成功但未返回可用地址": "Image uploaded but no usable URL was returned",
  "请填写「{0} / {1}」商家 SKU（seller_sku）": "Enter seller SKU for “{0} / {1}”",
  "「{0} / {1}」商家 SKU 不能包含空格（Create Product：Text without spaces）": "Seller SKU for “{0} / {1}” cannot contain spaces (Create Product: text without spaces)",
  "「{0} / {1}」商家 SKU 不能超过 {2} 个字符": "Seller SKU for “{0} / {1}” cannot exceed {2} characters",
  "商品名称超过上限（{0} 字符，当前 {1}）": "Product title exceeds the limit ({0} chars, now {1})",
  "英文名称超过上限（{0} 字符，当前 {1}）": "English title exceeds the limit ({0} chars, now {1})",
  "请输入颜色名称": "Enter a color name",
  "自定义颜色须为英文（平台不接受中文）。常见色名会自动转英文，其余请改用英文填写": "Custom colors must be English (Chinese is not accepted). Common names are auto-translated; otherwise enter English",
  "店铺 {0}": "Shop {0}",
  "接口 JSON：{0}": "API JSON: {0}",
  "接口 JSON": "API JSON",

  // --- TikTok utils Error/message (ensure/aiTitle/price/enroll/currency/rrp) ---
  "创建颜色规格「{0}」失败：未返回 specId": "Failed to create color spec “{0}”: no specId returned",
  "商品成本上涨": "Product cost increased",
  "物流履约费用上涨": "Fulfillment / shipping cost increased",
  "活动结束恢复价格": "Restore price after campaign ended",
  "物流履约费用上涨（物流规则调整）": "Fulfillment cost increased (logistics rule change)",
  "平台活动较多，本次仅核验了部分活动": "Many platform campaigns; only some were checked this time",
  "（活动：{0}）": "(campaign: {0})",
  "以下 SKU 处于平台营销活动价格锁定，不可涨价{0}：{1}。请先在 Seller Center 结束活动或等待活动结束。": "These SKUs are locked by a platform marketing campaign and cannot be raised{0}: {1}. End the campaign in Seller Center or wait until it ends.",
  "SKU {0} 缺少币种": "SKU {0} is missing currency",
  "改价接口无响应": "Price update API returned no response",
  "价格更新失败": "Price update failed",
  "售价已更新": "Sale price updated",
  "价格已更新": "Price updated",
  "站点 {0}": "Site {0}",
  "货品 {0} 请填写活动申报库存": "Product {0}: enter campaign declared stock",
  "货品 {0} 缺少 SKC 信息，请重新加载可报商品": "Product {0} is missing SKC info; reload enrollable products",
  "货品 {0} 存在无效 SKC": "Product {0} has an invalid SKC",
  "货品 {0} / SKC {1} 存在无效 SKU": "Product {0} / SKC {1} has an invalid SKU",
  "成功 {0}": "{0} succeeded",
  "失败 {0}": "{0} failed",
  "平台未返回报名结果": "Platform did not return an enrollment result",
  "报名完成：{0}": "Enrollment finished: {0}",
  "货品 {0}": "Product {0}",
  "；例如：{0}": "; e.g. {0}",
  "未从 Tiktok 发品规范解析到可用币种，供货价可能无法提交": "No usable currency from TikTok publish standard; supply price may fail to submit",
  "未从店铺站点列表解析到可用币种，售价可能无法提交": "No usable currency from shop site list; sale price may fail to submit",
  "售价币种「{0}」不在店铺可售站点币种中（可用：{1}）": "Sale currency “{0}” is not in the shop’s sellable site currencies (available: {1})",
  "供货价币种「{0}」不在 Tiktok 发品规范允许列表中（可用：{1}）": "Supply currency “{0}” is not in the TikTok publish-standard allowlist (available: {1})",
  "尚未获取建议零售价填写规则，请稍后重试或刷新页面": "RRP fill rules are not loaded yet; retry later or refresh the page",
  "建议零售价必填：请填写 {0} / {1} 的 {2} 价格": "Suggested retail price is required: enter the {2} price for {0} / {1}",
  "建议零售价缺少币种": "Suggested retail price is missing currency",
  "请按要求上传证明材料（{0}）：{1}": "Upload required proof materials ({0}): {1}",
  "当前品牌要求填写建议零售价": "This brand requires a suggested retail price",
  "德国站": "Germany",
  "法国站": "France",
  "意大利站": "Italy",
  "西班牙站": "Spain",
  "英国站": "United Kingdom",
  "美国站": "United States",
  "荷兰站": "Netherlands",
  "波兰站": "Poland",
  "瑞典站": "Sweden",
  "葡萄牙站": "Portugal",
  "欧洲站": "Europe",

  // --- tiktok publish payload / preflight / listingCheck / edit / outerPackage ---
  "未命名": "Unnamed",
  "…": "…",
  "；": "; ",
  "自定义颜色「{0}」须为英文（平台不接受中文）。常见色名会自动转英文，其余请改用英文填写": "Custom color “{0}” must be English (Chinese is not accepted). Common names are auto-translated; otherwise enter English",
  "颜色「{0}」缺少平台规格 ID，请重新选择或创建颜色规格": "Color “{0}” is missing a platform spec ID; reselect or create the color spec",
  "以下 SKU 缺少有效售价（须为 > 0 的数字）：{0}{1}": "These SKUs need a valid sale price (> 0): {0}{1}",
  "以下 SKU 库存须在 {0}–{1}：{2}{3}": "These SKUs need inventory in {0}–{1}: {2}{3}",
  "查询 Tiktok 发品规范失败，请稍后重试": "Failed to load TikTok publish standard; try again later",
  "【{0}】{1}": "[{0}] {1}",
  "店铺前置条件未通过：{0}": "Shop prerequisite failed: {0}",
  "店铺发品前置条件未通过，请先在 Seller Center 完成配置": "Shop listing prerequisites failed; finish setup in Seller Center first",
  "{0}（另有 {1} 项）": "{0} ({1} more)",
  "{0}（{1}）": "{0} ({1})",
  "商品信息核验未通过：{0}": "Product listing check failed: {0}",
  "平台发品核验未通过，请按提示修改后重试": "Platform listing check failed; fix the issues and retry",
  "店铺发品前置条件核验失败": "Shop listing prerequisites check failed",
  "平台发品核验失败，请稍后重试": "Platform listing check failed; try again later",
  "SKC#{0} 缺少平台 skc_name": "SKC#{0} is missing platform skc_name",
  "SKU#{0}-{1} 缺少平台 sku_code": "SKU#{0}-{1} is missing platform sku_code",
  "SKU#{0}-{1} 缺少商家 SKU（supplier_sku）": "SKU#{0}-{1} is missing seller SKU (supplier_sku)",
  "本地缺少平台规格编码，无法按「部分编辑」提交（{0}{1}）。请先在产品信息页拉取 TikTok 后台数据后再编辑。": "Local data is missing platform spec codes; cannot submit partial edit ({0}{1}). Pull TikTok backend data on the product page first, then edit.",
};

